webpackJsonp([1],{

/***/ "+pl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon loading-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M12,4V2C6.48,2 2,6.48 2,12H4C4,7.58 7.58,4 12,4Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "+uiI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon view-list-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M9,5V9H21V5M9,19H21V15H9M9,14H21V10H9M4,9H8V5H4M4,19H8V15H4M4,14H8V10H4V14Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "02d3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Delete_vue__ = __webpack_require__("efj3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_06ea22bd_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Delete_vue__ = __webpack_require__("JxEu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Delete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_06ea22bd_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Delete_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_06ea22bd_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Delete_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "16DI":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "1JkZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CloseIcon",
  props: {
    title: {
      type: String,
      default: "Close icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "1h/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoadingIcon",
  props: {
    title: {
      type: String,
      default: "Loading icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "2/UD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon eye-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M12,9C10.34,9 9,10.34 9,12C9,13.66 10.34,15 12,15C13.66,15 15,13.66 15,12C15,10.34 13.66,9 12,9M12,17C9.24,17 7,14.76 7,12C7,9.24 9.24,7 12,7C14.76,7 17,9.24 17,12C17,14.76 14.76,17 12,17M12,4.5C7,4.5 2.73,7.61 1,12C2.73,16.39 7,19.5 12,19.5C17,19.5 21.27,16.39 23,12C21.27,7.61 17,4.5 12,4.5Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "2AGJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon open-in-new-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V12H19V19Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "2xDA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return onSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return beforeRequestSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return beforeRequestError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_Auth__ = __webpack_require__("ZZwB");





var onSuccess = function onSuccess(response) {
  __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].dispatch('loading/setLoading', false);

  return response;
};

var onError = function onError(error) {

  switch (error.response.status) {
    case 403:
      __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].dispatch('auth/setOfflineMode', true);
      break;
    case 401:
      var originalRequest = error.config;
      if (!originalRequest._retry && error.response.data.error === 'TOKEN_EXPIRED') {
        originalRequest._retry = true;
        var refreshToken = __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getters['auth/refreshtoken'];
        return __WEBPACK_IMPORTED_MODULE_3__services_Auth__["a" /* default */].refresh(refreshToken).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].commit('auth/setAccessToken', response);
          return __WEBPACK_IMPORTED_MODULE_1_axios___default()(originalRequest);
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].dispatch('auth/logout');
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
        });
      }
      break;
    default:
      break;
  }

  __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].dispatch('loading/setLoading', false);

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
};

var beforeRequestSuccess = function beforeRequestSuccess(config) {
  __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].dispatch('loading/setLoading', true);
  config.headers.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getters['auth/accesstoken'];
  return config;
};

var beforeRequestError = function beforeRequestError(error) {
  __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].dispatch('loading/setLoading', false);
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
};



/***/ }),

/***/ "3LPc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteNavigation_vue__ = __webpack_require__("wv/a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b577a91a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteNavigation_vue__ = __webpack_require__("gZ2L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ZWa9")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b577a91a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SiteNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b577a91a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteNavigation_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b577a91a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SiteNavigation_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3fxR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_select2__ = __webpack_require__("hv7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_select2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_select2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_select2_dist_css_select2_min_css__ = __webpack_require__("A2Qj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_select2_dist_css_select2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_select2_dist_css_select2_min_css__);


//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Select2',
  data: function data() {
    return {
      select2: null
    };
  },

  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    settings: {
      type: Object,
      default: function _default() {}
    },
    value: null
  },
  watch: {
    options: function options(val) {
      this.setOption(val);
    },
    value: function value(val) {
      this.setValue(val);
    }
  },
  methods: {
    setOption: function setOption() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      this.select2.empty();
      this.select2.select2(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.settings, {
        data: val
      }));
      this.setValue(this.value);
    },
    setValue: function setValue(val) {
      if (val instanceof Array) {
        this.select2.val([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(val)));
      } else {
        this.select2.val([val]);
      }
      this.select2.trigger('change');
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.select2 = __WEBPACK_IMPORTED_MODULE_2_jquery___default()(this.$el).find('select').select2(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.settings, {
      data: this.options
    })).on('select2:select select2:unselect', function (ev) {
      _this.$emit('change', _this.select2.val());
      _this.$emit('select', ev['params']['data']);
    });
    this.setValue(this.value);
  },
  beforeDestroy: function beforeDestroy() {
    this.select2.select2('destroy');
  }
});

/***/ }),

/***/ "3jL2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("Ajl1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e3bc584_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("XBPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e3bc584_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e3bc584_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3wPs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CheckboxMarkedOutline_vue__ = __webpack_require__("aMAe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_11dad4f2_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CheckboxMarkedOutline_vue__ = __webpack_require__("vhOZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CheckboxMarkedOutline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_11dad4f2_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CheckboxMarkedOutline_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_11dad4f2_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CheckboxMarkedOutline_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Ggg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon lock-clock-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M8.5,2C6,2 4,4 4,6.5V7C2.89,7 2,7.89 2,9V18C2,19.11 2.89,20 4,20H8.72C10.18,21.29 12.06,22 14,22C18.42,22 22,18.42 22,14C22,9.58 18.42,6 14,6C13.66,6 13.32,6.03 13,6.08C12.76,3.77 10.82,2 8.5,2M8.5,4C9.88,4 11,5.12 11,6.5V7H6V6.5C6,5.12 7.12,4 8.5,4M14,8C17.31,8 20,10.69 20,14C20,17.31 17.31,20 14,20C10.69,20 8,17.31 8,14C8,10.69 10.69,8 14,8M13,10V15L16.64,17.19L17.42,15.9L14.5,14.15V10H13Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "4pyI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("1h/A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c9b5bc6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("+pl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c9b5bc6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4c9b5bc6_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Loading_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4ur8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CloseCircle_vue__ = __webpack_require__("x/9f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5b558199_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CloseCircle_vue__ = __webpack_require__("XfbO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CloseCircle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5b558199_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CloseCircle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5b558199_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CloseCircle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "503v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_event_hub__ = __webpack_require__("B6dM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privacy',
  data: function data() {
    return {
      active: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    loggedin: 'auth/loggedin'
  })),
  methods: {
    hide: function hide() {
      this.active = false;
    },
    show: function show() {
      this.active = true;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$on('privacy-show', this.show);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$off('privacy-show');
  }
});

/***/ }),

/***/ "67Oy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Security_vue__ = __webpack_require__("Iw6Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3517fc74_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Security_vue__ = __webpack_require__("Vi6C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Security_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3517fc74_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Security_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3517fc74_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Security_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6NTW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsList_vue__ = __webpack_require__("I5CX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530ab441_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsList_vue__ = __webpack_require__("cbTJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("kmFC")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530ab441_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_530ab441_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6eES":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon alert-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M13,14H11V10H13M13,18H11V16H13M1,21H23L12,2L1,21Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "7TVh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ArrowLeft_vue__ = __webpack_require__("b4RV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_483a4527_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ArrowLeft_vue__ = __webpack_require__("drpm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ArrowLeft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_483a4527_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ArrowLeft_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_483a4527_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ArrowLeft_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7nDA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings scrollbar settings-authenticator"},[_c('div',{staticClass:"settings-header"},[_c('button',{staticClass:"history-back",attrs:{"type":"button"},on:{"click":_vm.previous}},[_c('arrow-left-icon')],1),_vm._v("\n    Offline settings\n\n  ")]),_vm._v(" "),_c('hr',{staticClass:"settings-divider"}),_vm._v(" "),(!_vm.offlineMode)?_c('button',{staticClass:"block",attrs:{"type":"button"},on:{"click":_vm.switchToOffline}},[_c('cloud-off-outline-icon'),_vm._v(" "),_c('span',{staticClass:"settings-text"},[_vm._v("\n      Switch to offline mode\n    ")])],1):_vm._e(),_vm._v(" "),(_vm.offlineMode)?_c('button',{staticClass:"block",attrs:{"type":"button"},on:{"click":_vm.logoutUser}},[_c('cloud-outline-icon'),_vm._v(" "),_c('span',{staticClass:"settings-text"},[_vm._v("\n      Login again for online mode\n    ")])],1):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"settings-divider"}),_vm._v(" "),_c('form',{staticClass:"settings-body",on:{"submit":function($event){$event.preventDefault();_vm.storeNewEncryptKey($event)}}},[_c('p',[_vm._v("\n      Enable storing encrypted authenticators, favorites and settings offline by a password of your choosing. ")]),_vm._v(" "),_c('p',[_vm._v("If disabled, your session\n      is limited to 20 minutes and you will be switched into offline mode. Disabling offline mode will also remove any\n      offline stored data.")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col col-form-label",attrs:{"for":"offline_key"}},[_vm._v("Offline passphrase")]),_vm._v(" "),_c('div',{staticClass:"col-7"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newKey),expression:"newKey"}],staticClass:"form-control",attrs:{"type":"password","id":"offline_key"},domProps:{"value":(_vm.newKey)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.storeNewEncryptKey($event)},"input":function($event){if($event.target.composing){ return; }_vm.newKey=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[(!_vm.okey)?_c('button',{staticClass:"ml-auto btn purple darken-4 white-text px-4 z-depth-1",attrs:{"type":"button","disabled":!_vm.newKey},on:{"click":_vm.storeNewEncryptKey}},[_vm._v("\n        Enable offline\n      ")]):_vm._e(),_vm._v(" "),(_vm.okey)?_c('button',{staticClass:"ml-auto btn purple darken-4 white-text px-4 z-depth-1",attrs:{"type":"button","disabled":!_vm.newKey},on:{"click":_vm.storeNewEncryptKey}},[_vm._v("\n        Change passphrase\n      ")]):_vm._e()])]),_vm._v(" "),(_vm.okey)?_c('div',[_c('hr',{staticClass:"settings-divider"}),_vm._v(" "),_c('button',{staticClass:"block",attrs:{"type":"button"},on:{"click":_vm.deleteOfflineStore}},[_c('security-close-icon'),_vm._v(" "),_c('span',{staticClass:"settings-text"},[_vm._v("\n        Clear offline encrypted data\n      ")])],1),_vm._v(" "),_c('p',{staticClass:"text-muted pl-4"},[_vm._v("\n      Please note: when in offline mode it is not possible to retrieve new authenticators, settings or favorites\n      without first logging in again.")])]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "7vh6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("QDar");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13af5792_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("H8AT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13af5792_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13af5792_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8BXF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Lock_vue__ = __webpack_require__("YxxN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7fac2e9a_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Lock_vue__ = __webpack_require__("vHwb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Lock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7fac2e9a_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Lock_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7fac2e9a_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Lock_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8G/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfflineMode_vue__ = __webpack_require__("sHGq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e921d5e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfflineMode_vue__ = __webpack_require__("gYtk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Oluc")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e921d5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfflineMode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e921d5e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfflineMode_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e921d5e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfflineMode_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8Xx2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon help-circle-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7C10.9,7 10,7.9 10,9H8C8,6.79 9.79,5 12,5C14.21,5 16,6.79 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.47 17.5,2 12,2Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "8aDi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'feedback',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    feedback: 'feedback/feedback',
    feedbackClass: 'feedback/feedbackClass'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    clearFeedback: 'feedback/clearFeedback'
  })),
  watch: {
    $route: function $route() {
      this.clearFeedback();
    }
  }
});

/***/ }),

/***/ "8taH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'loading',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    isLoading: 'loading/isLoading',
    isAppLoading: 'loading/isAppLoading'
  }))
});

/***/ }),

/***/ "A/5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_event_hub__ = __webpack_require__("B6dM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_toastr__ = __webpack_require__("vQJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_v_select2_component__ = __webpack_require__("EZfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_Delete__ = __webpack_require__("02d3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_Reload__ = __webpack_require__("qTl2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_Download__ = __webpack_require__("NMje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_Upload__ = __webpack_require__("Lsay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_material_design_icons_ArrowLeft__ = __webpack_require__("7TVh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'authenticator-settings',
  components: {
    ArrowLeftIcon: __WEBPACK_IMPORTED_MODULE_10_vue_material_design_icons_ArrowLeft__["a" /* default */],
    UploadIcon: __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_Upload__["a" /* default */],
    DownloadIcon: __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_Download__["a" /* default */],
    ReloadIcon: __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_Reload__["a" /* default */],
    Select2: __WEBPACK_IMPORTED_MODULE_5_v_select2_component__["a" /* default */],
    DeleteIcon: __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_Delete__["a" /* default */]
  },
  data: function data() {
    return {
      fetching: false,
      form: {
        fieldId: false,
        templateId: false,
        advancedTemplate: false,
        newTemplateFilter: '',
        filterTemplateOn: ["auth"],
        newFieldFilter: '',
        filterFieldOn: ["restorecode", "authcode"]
      },
      showAdvanced: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    offlineMode: 'auth/offlineMode',
    filterTemplateOn: 'authenticators/filterTemplateOn',
    filterFieldOn: 'authenticators/filterFieldOn',
    secrettemplates: 'secretTemplates/all',
    getTemplateById: 'secretTemplates/getById',
    templateId: 'authenticators/templateId',
    showOtp: 'settings/showOtp',
    okey: 'settings/okey',
    advancedTemplate: 'settings/advancedTemplate'
  }), {
    template: function template() {
      if (this.templateId) {
        return this.getTemplateById(this.templateId);
      }
      return false;
    },
    possibleAuthenticatorTemplates: function possibleAuthenticatorTemplates() {
      var _this = this;

      if (this.secrettemplates) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(this.secrettemplates, function (template) {
          var name = _this.multiIncludes(template.text, _this.filterTemplateOn);

          if (name) {
            return true;
          }
        });
      }
      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    addFieldFilter: 'authenticators/addFieldFilter',
    addTemplateFilter: 'authenticators/addTemplateFilter',
    removeFieldFilter: 'authenticators/removeFieldFilter',
    removeTemplateFilter: 'authenticators/removeTemplateFilter',
    resetTemplateFilter: 'authenticators/resetTemplateFilter',
    resetFieldFilter: 'authenticators/resetFieldFilter'
  }), {
    multiIncludes: function multiIncludes(text, values) {
      var re = new RegExp(values.join('|'), 'i');
      return re.test(text);
    },
    showHelp: function showHelp() {
      __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$emit('help-show');
    },
    refreshAuthenticators: function refreshAuthenticators(e) {
      var _this2 = this;

      e.preventDefault();
      this.fetching = true;
      this.$store.dispatch('authenticators/clearAll');
      this.$store.dispatch('asyncData').then(function () {
        return __WEBPACK_IMPORTED_MODULE_4_toastr__["success"]('Authenticators retrieved.');
      }).catch(function () {
        return __WEBPACK_IMPORTED_MODULE_4_toastr__["error"]('Unable to fetch authenticators.');
      }).finally(function () {
        _this2.fetching = false;
        _this2.$router.push({ name: 'authenticators' });
      });
    },
    previous: function previous() {
      return this.$router.push({ name: 'settings' });
    },
    toggleShowAdvanced: function toggleShowAdvanced() {
      this.showAdvanced = !this.showAdvanced;
    },
    postTemplateFilter: function postTemplateFilter() {
      if (this.form.newTemplateFilter !== '') {
        this.addTemplateFilter(this.form.newTemplateFilter);
        this.form.newTemplateFilter = '';
      }
    },
    postFieldFilter: function postFieldFilter() {
      if (this.form.newFieldFilter !== '') {
        this.addFieldFilter(this.form.newFieldFilter);
        this.form.newFieldFilter = '';
      }
    },
    deleteOfflineStore: function deleteOfflineStore() {
      if (confirm("Do you want to remove your offline data?")) {
        // eslint-disable-line no-alert
        this.form.offline = false;
        this.$store.commit('settings/setOkey', null);
        this.post(this.form);
      }
    },
    post: function post(form) {
      if (!this.offlineMode) {

        if (this.form.templateId) {
          this.$store.commit('authenticators/setTemplateId', this.form.templateId);
        }

        this.$store.commit('settings/setAdvancedTemplate', this.form.advancedTemplate);
        this.$store.commit('settings/setShowOtp', this.form.show);
        __WEBPACK_IMPORTED_MODULE_4_toastr__["success"]('Settings saved');
      }
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    if (this.templateId) {
      this.form.templateId = this.templateId;
    }
    if (this.fieldId) {
      this.form.fieldId = this.fieldId;
    }
    if (this.showOtp) {
      this.form.show = this.showOtp;
    }
    if (this.advancedTemplate) {
      this.form.advancedTemplate = this.advancedTemplate;
    }
    if (this.filterFieldOn) {
      this.form.filterFieldOn = this.filterFieldOn;
    }
    if (!this.offlineMode) {
      this.$store.dispatch('secretTemplates/getSecretTemplates').catch(function (e) {
        if (e.status == 400 && e.data.errorCode === "API_AccessDenied") {
          _this3.form.advancedTemplate = true;
        }
      });
    }
  }
});

/***/ }),

/***/ "A2Qj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AQ8/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__("wtEF");

// import Auth from '../../services/Auth';

/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {

  if (!__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].state.loading.appLoading) {
    return next();
  }

  var templateId = localStorage.getItem('templateId');
  if (templateId && templateId !== 'false') {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('authenticators/setTemplateId', templateId);
  }

  var showOtp = localStorage.getItem('showOtp');
  if (showOtp && showOtp !== 'false') {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('settings/setShowOtp', showOtp);
  }

  var advancedTemplate = localStorage.getItem('advancedTemplate');
  if (advancedTemplate && advancedTemplate !== 'false') {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('settings/setAdvancedTemplate', advancedTemplate);
  }

  var templateFilter = localStorage.getItem('templateFilter');
  if (templateFilter) {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('authenticators/setTemplateFilter', JSON.parse(templateFilter));
  }

  var fieldFilter = localStorage.getItem('fieldFilter');
  if (fieldFilter) {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].commit('authenticators/setFieldFilter', JSON.parse(fieldFilter));
  }

  __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].dispatch('loading/setAppLoading', false);
  return next();
});

/***/ }),

/***/ "AiJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  feedback: {
    message: false,
    type: false
  }
};

var getters = {
  feedback: function feedback(state, getters, rootState, rootGetters) {
    return state.feedback;
  },
  feedbackClass: function feedbackClass() {
    var type = state.feedback.type;
    return 'alert alert-' + type;
  }
};

var actions = {
  setFeedback: function setFeedback(_ref, data) {
    var commit = _ref.commit;

    commit('setFeedback', data);
  },
  setDelayedFeedback: function setDelayedFeedback(_ref2, data) {
    var commit = _ref2.commit;

    setTimeout(function () {
      commit('setFeedback', data.feedback);
    }, data.delay || 10);
  },
  clearFeedback: function clearFeedback(_ref3) {
    var commit = _ref3.commit;

    commit('clearFeedback');
  }
};

var mutations = {
  setFeedback: function setFeedback(state, data) {
    state.feedback.message = data.message;
    state.feedback.type = data.type;
  },
  clearFeedback: function clearFeedback(state) {
    state.feedback.message = false;
    state.feedback.type = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Ajl1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_event_hub__ = __webpack_require__("B6dM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Feedback__ = __webpack_require__("OZEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Settings__ = __webpack_require__("7vh6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_Settings__ = __webpack_require__("YRA+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_toastr__ = __webpack_require__("vQJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_toastr__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










__WEBPACK_IMPORTED_MODULE_8_toastr__["options"].timeout = 1500;

var keySize = 256;
var iterations = 100;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  components: {
    Feedback: __WEBPACK_IMPORTED_MODULE_4__Feedback__["a" /* default */],
    Settings: __WEBPACK_IMPORTED_MODULE_5__Settings__["a" /* default */],
    SettingsIcon: __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_Settings__["a" /* default */]
  },
  data: function data() {
    return {
      short: false,
      stepper: false,
      step: 1,
      form: {
        url: '',
        username: '',
        password: '',
        OTP: '',
        domain: ''
      },
      newTemplateId: false,
      showOtp: false,
      showOffline: false,
      newKey: '',
      offlineKey: '',
      rememberUrl: true,
      rememberUser: true,
      rememberDomain: true,
      preferences: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    isLoading: 'loading/isLoading',
    loggedIn: 'auth/loggedin',
    storeOffline: 'settings/storeOffline',
    templateId: 'authenticators/templateId',
    okey: 'settings/okey'
  }), {
    version: function version() {
      return "1.2.3";
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    setFeedback: 'feedback/setFeedback',
    setDelayedFeedback: 'feedback/setDelayedFeedback',
    setDomain: 'settings/setDomain',
    login: 'auth/login',
    getPreferences: 'authenticators/getPreferences',
    getCompanyPreferences: 'authenticators/getCompanyPreferences'
  }), {
    showHelp: function showHelp() {
      __WEBPACK_IMPORTED_MODULE_2__events_event_hub__["a" /* default */].$emit('help-show');
    },
    showDisclaimer: function showDisclaimer() {
      __WEBPACK_IMPORTED_MODULE_2__events_event_hub__["a" /* default */].$emit('disclaimer-show');
    },
    showPrivacy: function showPrivacy() {
      __WEBPACK_IMPORTED_MODULE_2__events_event_hub__["a" /* default */].$emit('privacy-show');
    },
    storeNewEncryptKey: function storeNewEncryptKey() {
      if (this.newKey !== '') {
        // let key = this.encrypt(this.form.newKey, this.form.newKey);
        this.$store.commit('settings/setStoreOffline', true);
        this.$store.commit('settings/encryptOkey', this.newKey);
        this.offlineKey = '';
        this.$router.replace({ name: 'authenticators' });
        __WEBPACK_IMPORTED_MODULE_8_toastr__["success"]('Storing encrypted data offline is enabled.');
      }
    },
    toggleStepper: function toggleStepper() {
      this.stepper = !this.stepper;
    },
    setStep: function setStep(i) {
      if (i == 4 && this.loggedIn && this.okey) {
        this.$router.replace({ name: 'authenticators' });
      }
      if (i >= 3 && !this.loggedIn) {
        // Login form
        this.setFeedback({
          message: 'Please login first.',
          type: 'info'
        });
        this.step = 2;
      } else {
        this.step = i;
        // if (i == 4 && this.okey !== null && this.okey !== '') {
        //   this.$router.replace({name: 'authenticators'});
        // }
      }
    },
    storeTemplateId: function storeTemplateId() {
      if (this.preferences !== 3 && this.newTemplateId !== null && this.newTemplateId !== '') {
        this.$store.commit('authenticators/setTemplateId', this.newTemplateId);
      }
      this.setStep(4);
    },
    processRemembers: function processRemembers() {
      this.$store.commit('auth/setUrl', this.form.url);
      if (this.rememberUrl) {
        localStorage.setItem('url', this.form.url);
      } else {
        localStorage.removeItem('url');
      }
      if (this.rememberUser) {
        localStorage.setItem('user', this.form.username);
      } else {
        localStorage.removeItem('user');
      }
      if (this.rememberDomain) {
        localStorage.setItem('domain', this.form.domain);
      } else {
        localStorage.removeItem('domain');
      }
    },
    wizardLogin: function wizardLogin() {
      var _this = this;

      if (this.form.password == '') return;
      this.processRemembers();

      this.login({ form: this.form }).then(function () {

        _this.setStep(3);

        _this.getPreferences(true).then(function (resp) {

          _this.preferences = resp;

          if (resp == 0) {
            return _this.getCompanyPreferences().then(function (resp) {
              _this.preferences = resp;
            });
          }
        }).finally(function () {

          _this.newTemplateId = _this.templateId;
        });
      }).catch(function (error) {
        if (error.data) {

          _this.form.OTP = '';
          switch (error.data.error) {
            default:
              _this.setFeedback({ message: error.data.error, type: 'warning' });
              break;
            case "Invalid Google Authenticator pin code.":
              _this.setFeedback({
                feedback: {
                  message: 'The OTP is incorrect.',
                  type: 'info'
                }
              });
              break;
          }
        }
      });
    },
    post: function post() {
      var _this2 = this;

      if (this.form.password == '') return;
      this.processRemembers();

      this.login({ form: this.form }).then(function () {
        // this.form.password = "";

        _this2.$router.replace({ path: '/' });
      }).catch(function (error) {
        if (error.data) {

          _this2.form.OTP = '';
          switch (error.data.error) {
            default:
              _this2.setFeedback({ message: error.data.error, type: 'warning' });
              _this2.showLogin();
              document.getElementById('password').focus();
              break;
            case "Invalid Google Authenticator pin code.":
              _this2.otp();
              break;
          }
        }
      });
    },
    deleteOfflineStore: function deleteOfflineStore() {
      if (confirm("Do you want to remove your offline data?")) {
        // eslint-disable-line no-alert
        localStorage.removeItem('store');
        this.showLogin();
      }
    },
    showLogin: function showLogin() {
      this.showOffline = false;
      this.showOtp = false;
    },
    otp: function otp() {
      this.showOffline = false;
      this.showOtp = true;
    },
    decrypt: function decrypt(transitmessage, pass) {
      var domain = false;
      if (this.form.domain !== "") {
        domain = this.form.domain.toLowerCase();
      }
      var sha = __WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.SHA512(pass + domain).toString(__WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.enc.Hex);
      var salt = __WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.enc.Hex.parse(transitmessage.substr(0, 32));
      var iv = __WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.enc.Hex.parse(transitmessage.substr(32, 32));
      var encrypted = transitmessage.substring(64);

      var key = __WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.PBKDF2(sha, salt, {
        keySize: keySize / 32,
        iterations: iterations
      });

      var decrypted = __WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.AES.decrypt(encrypted, key, {
        iv: iv,
        padding: __WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.pad.Pkcs7,
        mode: __WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.mode.CBC

      });
      return decrypted;
    },
    parseOkey: function parseOkey() {
      var _this3 = this;

      var storedData = localStorage.getItem('store');
      var success = false;
      var stored = false;
      if (storedData) {
        try {
          stored = JSON.parse(this.decrypt(storedData, this.offlineKey).toString(__WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.enc.Utf8));

          if (stored.authenticators) {
            success = true;
          }
        } catch (err) {}
      }
      if (success) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([this.$store.commit('loading/setAppLoading', true), this.$store.commit('auth/loadOffline', stored.auth), this.$store.commit('settings/loadOffline', stored.settings), this.$store.commit('authenticators/loadOffline', stored.authenticators), this.$store.commit('secretTemplates/loadOffline', stored.secretTemplates)]).then(function () {
          _this3.$store.dispatch('auth/authenticate').then(function () {
            _this3.$router.replace({ path: '/' });
            _this3.$store.commit('loading/setAppLoading', false);
          }).catch(function () {
            _this3.$router.replace({ path: '/' });
            _this3.$store.commit('auth/setOfflineMode', true);
            _this3.$store.commit('loading/setAppLoading', false);
          });
        });
      } else {
        this.setFeedback({ message: 'Sorry, the offline passphrase is incorrect.', type: 'warning' });
      }
    },
    parseOffline: function parseOffline() {
      var _this4 = this;

      var storedData = localStorage.getItem('store');
      if (storedData) {
        try {
          var dec = __WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.AES.decrypt(storedData, this.offlineKey).toString(__WEBPACK_IMPORTED_MODULE_7_crypto_js___default.a.enc.Latin1);
          var stored = JSON.parse(dec);

          if (stored.authenticators) {
            this.$store.commit('authenticators/loadOffline', stored.authenticators).then(function () {
              _this4.$router.replace({ path: '/' });
            });
          }
        } catch (err) {
          localStorage.removeItem('store');
        }
      }
    }
  }),
  mounted: function mounted() {
    var url = localStorage.getItem('url');
    if (url !== null && url !== 'undefined') {
      this.form.url = url;
      this.rememberUrl = true;
    }
    var user = localStorage.getItem('user');
    if (user !== null && user !== 'undefined') {
      this.form.username = user;
      this.rememberUser = true;
    }
    var domain = localStorage.getItem('domain');
    if (domain !== null && domain !== 'undefined') {
      this.form.domain = domain;
      this.rememberDomain = true;
    }
    if (localStorage.getItem('store')) {
      if (this.loggedIn) {
        this.setDelayedFeedback({
          message: 'Offline store detected, logging in will preserve the predefined offline-key.',
          type: 'warning'
        });
      } else {
        this.showOffline = true;
      }
    }
    var stepper = localStorage.getItem('stepper');
    if (this.form.domain === "" && stepper !== false) {
      this.step = 1;
      this.stepper = true;
    }
    if (this.$route.query.in && this.$route.query.in == 1) {
      this.showOffline = false;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.form.username = '';
    this.form.password = '';
    this.form.otp = '';
    this.offlineKey = '';
  }
});

/***/ }),

/***/ "AnFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_Eye__ = __webpack_require__("toqK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_EyeOff__ = __webpack_require__("CfOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_ContentCopy__ = __webpack_require__("WZhI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_Loading__ = __webpack_require__("4pyI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_Reload__ = __webpack_require__("qTl2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_Magnify__ = __webpack_require__("xPdf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_material_design_icons_CloseCircle__ = __webpack_require__("4ur8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_toastr__ = __webpack_require__("vQJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__node_modules_vue_material_design_icons_OpenInNew_vue__ = __webpack_require__("JtXI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Authenticator_vue__ = __webpack_require__("xZLE");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















__WEBPACK_IMPORTED_MODULE_11_toastr__["options"].timeout = 1500;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Authenticators',
  components: {
    Authenticator: __WEBPACK_IMPORTED_MODULE_13__Authenticator_vue__["a" /* default */],
    OpenInNewIcon: __WEBPACK_IMPORTED_MODULE_12__node_modules_vue_material_design_icons_OpenInNew_vue__["a" /* default */],
    EyeIcon: __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_Eye__["a" /* default */],
    EyeOffIcon: __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_EyeOff__["a" /* default */],
    ContentCopyIcon: __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_ContentCopy__["a" /* default */],
    LoadingIcon: __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_Loading__["a" /* default */],
    ReloadIcon: __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_Reload__["a" /* default */],
    MagnifyIcon: __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_Magnify__["a" /* default */],
    CloseCircleIcon: __WEBPACK_IMPORTED_MODULE_10_vue_material_design_icons_CloseCircle__["a" /* default */]
  },
  data: function data() {
    return {
      time: 0,
      dispatched: {},
      query: '',
      queryHasResult: true,
      sortSelected: 'name',
      sortOptions: [{ label: 'Name', value: 'name' }],
      sortBy: 0,
      sortByOptions: [{ label: 'A-Z', value: 0 }, { label: 'Z-A', value: 1 }],
      create: false,
      edit: false,
      loading: false,
      interval: null,
      dispatching: false,
      filter: 0,
      scrollbar: {
        totalHeight: 0,
        currentHeight: 0,
        beforeHeight: 0,
        afterHeight: 0,
        scrolled: 0,
        total: 0,
        range: 5,
        show: 15,
        current: 0,
        first: 0,
        last: 15,
        from: 0,
        to: 15,
        magic: 118
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    url: 'auth/url',
    offlineMode: 'auth/offlineMode',
    secrets: 'authenticators/all',
    templateId: 'authenticators/templateId',
    personalFolderId: 'authenticators/personalFolderId',
    showOtp: 'settings/showOtp',
    okey: 'settings/okey',
    favorites: 'authenticators/favorites'
  }), {
    favoriteFeature: function favoriteFeature() {
      return this.okey || this.favorites.length >= 1 || !this.offlineMode;
      // return (!this.offlineMode && this.okey && this.personalFolderId) || this.favorites.length >= 1;
    },
    secretsCount: function secretsCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.secrets).length;
    },
    sb: function sb() {
      this.calcScroll();
      return this.scrollbar.totalHeight + "px";
    },
    currentHeight: function currentHeight() {
      return this.scrollbar.currentHeight + "px";
    },
    beforeHeight: function beforeHeight() {
      return this.scrollbar.beforeHeight + "px";
    },
    afterHeight: function afterHeight() {
      return this.scrollbar.afterHeight + "px";
    },
    filteredSecrets: function filteredSecrets() {
      var _this = this;

      var list = this.secrets;
      if (this.query && list) {
        list = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(list, function (secret) {
          var name = secret.name.toLowerCase().indexOf(_this.query.toLowerCase()) !== -1;
          if (name) {
            return true;
          }
        });
      }
      if (list && this.filter === 1) {
        list = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(list, function (secret) {
          return _this.favorites.includes(secret.id);
        });
      }
      list = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(list, function (el) {
        return el[_this.sortSelected].toLowerCase();
      });
      list.forEach(function (secret) {
        if (!secret.items && !_this.dispatched[secret.id]) {
          _this.dispatched[secret.id] = true;
          _this.$store.dispatch('authenticators/getAuthenticator', secret.id);
        }
      });
      if (this.sortBy) list.reverse();
      return list;
    },
    slicedSecrets: function slicedSecrets() {
      return this.filteredSecrets.slice(this.scrollbar.from, this.scrollbar.to);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    getAuthenticator: 'authenticators/getAuthenticator',
    generateOtp: 'authenticators/generateOtp',
    setLoading: 'loading/setLoading',
    setDelayedFeedback: 'feedback/setDelayedFeedback',
    toggleShowOtp: 'authenticators/toggleShowOtp',
    getPreferences: 'authenticators/getPreferences',
    getCompanyPreferences: 'authenticators/getCompanyPreferences',
    getPersonalFolderId: 'authenticators/getPersonalFolderId'
  }), {
    setFilter: function setFilter(id) {
      this.filter = id;
      this.calcScroll();
    },
    secretUrl: function secretUrl(id) {
      return this.url + '/SecretView.aspx?secretid=' + id;
    },
    refreshAuthenticators: function refreshAuthenticators() {
      var _this2 = this;

      this.dispatching = true;
      this.$store.dispatch('authenticators/clearAll');
      this.$store.dispatch('asyncData').then(function () {
        _this2.dispatching = false;
      });
      this.filter = 0;
      this.dispatched = {};
    },
    timer: function timer() {
      var epoch = Math.round(new Date().getTime() / 1000.0);
      var countDown = 30 - epoch % 30;
      this.time = countDown;
      return countDown;
    },
    copy: function copy(id) {
      if (this.secrets[id].otp === 'undefined') {
        __WEBPACK_IMPORTED_MODULE_11_toastr__["error"]('Unable to copy.');
        return false;
      }
      return this.clip(this.secrets[id].otp);
    },
    clip: function clip(str) {
      var el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      var selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
        __WEBPACK_IMPORTED_MODULE_11_toastr__["success"]('One Time Password copied');
      }
    },
    clearQuery: function clearQuery() {
      if (this.query) {
        this.query = '';
      }
    },
    scrollToId: function scrollToId(id) {
      var pos = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findLastIndex(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.toArray(this.filteredSecrets), { id: id });
      document.getElementById('ccl').scrollTop = this.scrollbar.magic * pos;
    },

    calcScroll: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
      var sb = this.scrollbar;
      var r = sb.range + sb.show;

      sb.total = this.filteredSecrets.length;
      if (sb.total > sb.current) {
        sb.current = Math.floor(sb.scrolled / sb.magic);
      } else {
        sb.current = 0;
      }

      sb.first = sb.current > r ? sb.current - r : 0;
      sb.last = r + sb.first;

      sb.from = sb.current >= sb.range ? sb.current - sb.range : 0;
      sb.to = r + sb.from;

      sb.totalHeight = sb.total * sb.magic;
      sb.currentHeight = sb.from ? sb.total - sb.from : (sb.current > r ? r : sb.total) * sb.magic;
      sb.beforeHeight = this.create ? sb.from * sb.magic - sb.magic : sb.from * sb.magic;
    }, 150),
    sbTop: function sbTop() {
      var _this3 = this;

      document.getElementById('ccl').scrollTop = 0;
      this.scrollbar.scrolled = 0;
      setTimeout(function () {
        _this3.calcScroll();
      }, 500);
    },
    scroll: function scroll(h) {
      this.scrollbar.scrolled = h;
      this.calcScroll();
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    if (!this.templateId) {
      this.getPreferences(true).then(function (resp) {
        if (resp) {
          _this4.refreshAuthenticators();
        } else {
          _this4.getCompanyPreferences().then(function (resp) {
            if (resp < 4) {
              _this4.setDelayedFeedback({
                feedback: {
                  message: 'Almost there, there is a configuration to complete',
                  type: 'info'
                }
              });
              _this4.$router.push('settings');
            } else {
              _this4.refreshAuthenticators();
            }
          });
        }
      });
      return;
    }
    if (!this.personalFolderId) {
      this.getPersonalFolderId();
    }

    if (this.favorites && this.favorites.length >= 1) {
      this.filter = 1;
    }

    this.interval = setInterval(function () {
      this.timer();
    }.bind(this), 1000);

    var ccl = document.getElementById('ccl');
    ccl.onscroll = function () {
      _this4.scroll(ccl.scrollTop);
    };
    this.calcScroll();
  },
  created: function created() {
    if (this.templateId !== false && !this.offlineMode && this.secretsCount <= 0 && !this.offlineMode) {
      this.$store.dispatch('asyncData');
    }
    if (this.interval === null) {
      this.interval = setInterval(function () {
        this.timer();
      }.bind(this), 1000);
    }
    this.timer();
    this.calcScroll();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.interval);
  }
});

/***/ }),

/***/ "AqLG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



// import Vue from 'vue';




/* harmony default export */ __webpack_exports__["a"] = ({
  getAuthenticators: function getAuthenticators(params) {
    var url = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/url'];
    var templateId = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['authenticators/templateId'];
    if (params == null) {
      params = {};
    }
    params['filter.includeSubFolders'] = true;
    params['filter.secretTemplateId'] = templateId;
    params['take'] = 128;
    var urlQuery = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
      return key + '=' + params[key];
    }).join('&');
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + '/api/v1/secrets?' + urlQuery).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  getStub: function getStub() {
    var url = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/url'];
    var params = {};
    params['filter.secretTemplateId'] = 9;
    params['filter.folderId'] = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['authenticators/personalFolderId'];
    var urlQuery = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
      return key + '=' + params[key];
    }).join('&');
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + '/api/v1/secrets/stub?' + urlQuery).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  getAuthenticator: function getAuthenticator(id) {
    var url = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + ('/api/v1/secrets/' + id)).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  searchSecrets: function searchSecrets(params) {
    var url = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/url'];
    if (params == null) {
      params = {};
    }
    var urlQuery = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
      return key + '=' + params[key];
    }).join('&');
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + '/api/v1/secrets?' + urlQuery).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  getSecret: function getSecret(id) {
    var url = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + ('/api/v1/secrets/' + id)).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  postSecret: function postSecret(payload) {
    var url = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url + '/api/v1/secrets', payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  postSecretById: function postSecretById(payload, id) {
    var url = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url + '/api/v1/secrets/' + id, payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  getPersonalFolders: function getPersonalFolders() {
    var url = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/url'];
    var params = {};
    params['filter.searchText'] = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/user'].displayName;
    params['filter.includeSubFolders'] = true;
    params.take = 1;
    var urlQuery = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(params).map(function (key) {
      return key + '=' + params[key];
    }).join('&');
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url + '/api/v1/folders?' + urlQuery).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  putSecret: function putSecret(id, payload) {
    var url = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url + ('/api/v1/secrets/' + id), payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  getPersonalFolderId: function getPersonalFolderId() {
    this.getPersonalFolders().then(function (response) {
      if (typeof response.records !== 'undefined' && response.records.length >= 1) {
        var displayName = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/user'].displayName;
        response.records.forEach(function (record) {
          // Check for displayname AND "Personal Folders"
          if (record.folderName.indexOf(displayName) !== -1 && record.folderPath.indexOf("Personal Folders") !== -1) {
            __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('authenticators/setPersonalFolderId', record.id);
          }
        });
      }
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  getCompanyPreferences: function getCompanyPreferences() {
    var _this = this;

    var params = {};
    var searchText = '4pa_autodiscover_';
    if (__WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['settings/domain']) {
      searchText += __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['settings/domain'] + '_';
    }
    searchText += 'preferences';
    params['filter.searchText'] = searchText;
    params['filter.includeSubFolders'] = true;
    params.take = 1;
    return this.searchSecrets(params).then(function (data) {
      if (data.total >= 1) {
        return _this.getAuthenticator(data.records[0].id).then(function (secret) {
          var authPrefs = null;
          secret.items.forEach(function (item) {
            if (item.slug === 'notes') {
              try {
                var json = JSON.parse(item.itemValue);
                authPrefs = json.templateId;
              } catch (e) {
                authPrefs = Number(item.itemValue);
              }
            }
          });
          if (authPrefs) {
            __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('authenticators/setTemplateId', authPrefs);
          }
          __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('authenticators/setSettingsId', data.records[0].id);
          return 4;
        });
      } else {
        return 2;
      }
      return 1;
    });
  },
  getPreferences: function getPreferences(configure) {
    var _this2 = this;

    var params = {};
    var searchText = '4pa_user_';
    if (__WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['settings/domain']) {
      searchText += __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['settings/domain'] + '_';
    }
    searchText += __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/user'].userName + '_preferences';
    params['filter.searchText'] = searchText;
    params['filter.includeSubFolders'] = true;
    params.take = 1;
    return this.searchSecrets(params).then(function (data) {
      if (data.total >= 1) {
        if (configure) {
          return _this2.getAuthenticator(data.records[0].id).then(function (secret) {

            var authPrefs = null;
            secret.items.forEach(function (item) {
              if (item.slug === 'notes') {
                authPrefs = JSON.parse(item.itemValue);
              }
            });
            if (authPrefs) {
              __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('settings/setOkey', authPrefs.okey);
              __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('authenticators/setFavorites', authPrefs.favorites);
              __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('authenticators/setTemplateId', authPrefs.templateId);
              __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('settings/setShowOtp', authPrefs.showOtp);
            }
            __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('authenticators/setSettingsId', data.records[0].id);
            return 3;
          });
        } else {
          return 2;
        }
        return 1;
      }
      return 0;
    });
  },
  postPreferences: function postPreferences() {
    var _this3 = this;

    var params = {};
    var searchText = '4pa_user_';
    if (__WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['settings/domain']) {
      searchText += __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['settings/domain'] + '_';
    }
    searchText += __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/user'].userName + '_preferences';
    params['filter.searchText'] = searchText;
    params['filter.includeSubFolders'] = true;
    params.take = 1;

    return this.searchSecrets(params).then(function (data) {
      if (data.total >= 1) {
        return _this3.getAuthenticator(data.records[0].id).then(function (secret) {
          secret.items.forEach(function (item) {
            if (item.slug === "notes") {

              var preferences = {
                okey: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['settings/okey'],
                templateId: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['authenticators/templateId'],
                favorites: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['authenticators/favorites'],
                showOtp: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['settings/showOtp']
              };
              item.itemValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(preferences);
            }
          });

          return _this3.postSecretById(secret, secret.id);
        });
      } else {

        return _this3.getStub().then(function (stub) {
          var name = searchText;
          var items = [];
          stub.items.forEach(function (item) {
            if (item.slug === "url") {
              item.itemValue = __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['auth/url'];
              items.push(item);
            }
            if (item.slug === "username") {
              item.itemValue = "4pa_authenticators";
              items.push(item);
            }
            if (item.slug === "password") {
              item.itemValue = "00000000";
              items.push(item);
            }
            if (item.slug === "notes") {
              var preferences = {
                okey: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['settings/okey'],
                templateId: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['authenticators/templateId'],
                favorites: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['authenticators/favorites'],
                showOtp: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['settings/showOtp']
              };
              item.itemValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(preferences);
              items.push(item);
            }
          });
          var secretCreateArgs = {
            name: name,
            // SecretTemplate: Web password
            SecretTemplateId: 9,
            folderId: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['authenticators/personalFolderId'],
            SiteId: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters['authenticators/siteId'],
            Items: items
          };

          return _this3.postSecret(secretCreateArgs);
        });
      }
    });
  }
});

/***/ }),

/***/ "B6dM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var EventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (EventHub);

/***/ }),

/***/ "BunX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon checkbox-marked-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.89 20.1,3 19,3Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "Cbhb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Secrets__ = __webpack_require__("bNYJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");



var addModel = function addModel(state, model) {
  // data mutate
  model.text = model.name;
  delete model.name;
  model.retrieved = false;
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.all, model.id, model);
};
var retrieveModel = function retrieveModel(state, model) {
  model.text = model.name;
  delete model.name;
  model.retrieved = true;
  __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].set(state.all, model.id, model);
};

var state = {
  all: {}
};

var getters = {
  all: function all() {
    return state.all;
  },
  getById: function getById(state) {
    return function (id) {
      return state.all[id];
    };
  }
};

var actions = {
  getSecretTemplates: function getSecretTemplates(_ref) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_0__services_Secrets__["a" /* default */].getSecretTemplates().then(function (data) {
      return commit('receiveAll', data.records);
    });
  },
  getSecretTemplate: function getSecretTemplate(_ref2, payload) {
    var commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_0__services_Secrets__["a" /* default */].getSecretTemplate(payload).then(function (data) {
      return commit('retrieve', data);
    });
  },
  clearState: function clearState(_ref3) {
    var commit = _ref3.commit;

    return commit('clearState');
  }
};

var mutations = {
  clearState: function clearState(state) {
    state = {
      all: {}
    };
  },
  receiveAll: function receiveAll(state, models) {
    models.forEach(function (model) {
      addModel(state, model);
    });
  },
  retrieve: function retrieve(state, model) {
    retrieveModel(state, model);
  },
  loadOffline: function loadOffline(state, store) {
    state.all = store.all;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "CfOl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EyeOff_vue__ = __webpack_require__("OMbd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_41920ccf_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_EyeOff_vue__ = __webpack_require__("WcsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EyeOff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_41920ccf_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_EyeOff_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_41920ccf_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_EyeOff_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Auth__ = __webpack_require__("ZZwB");


var state = {
  loggedin: false,
  offlineMode: false,
  user: false,
  tokens: {
    access: null,
    accessExpiresIn: null
  },
  url: false
};

var getters = {
  user: function user() {
    return state.user;
  },
  loggedin: function loggedin() {
    return state.loggedin;
  },
  accesstoken: function accesstoken() {
    return state.tokens.access;
  },
  expiry: function expiry() {
    return state.tokens.accessExpiresIn;
  },
  auth: function auth() {
    return state;
  },
  url: function url() {
    return state.url;
  },
  offlineMode: function offlineMode() {
    return state.offlineMode;
  }
};

var actions = {
  login: function login(_ref, credentials) {
    var _this = this;

    var commit = _ref.commit;

    commit('settings/setDomain', credentials.form.domain, { root: true });
    return __WEBPACK_IMPORTED_MODULE_0__services_Auth__["a" /* default */].login(credentials).then(function (data) {
      commit('setAccessToken', data.access_token);
      commit('setAccessExpiresIn', data.expires_in);
      commit('setLoggedIn', true);
      commit('setOfflineMode', false);
      return _this.dispatch('auth/authenticate');
    });
  },
  authenticate: function authenticate(_ref2) {
    var commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_0__services_Auth__["a" /* default */].authenticate().then(function (data) {
      commit('setLoggedIn', true);
      commit('setUser', data);
    });
  },
  logout: function logout(_ref3) {
    var commit = _ref3.commit;

    commit('setLoggedIn', false);
    commit('setUser', false);
    commit('clearAccessToken', false);
    commit('authenticators/clearState', null, { root: true });
    commit('secretTemplates/clearState', false, { root: true });
    commit('settings/clearState', false, { root: true });
    // commit('clearRefreshToken', false);
  },
  setOfflineMode: function setOfflineMode(_ref4, status) {
    var commit = _ref4.commit;

    commit('setOfflineMode', status);
  }
};

var mutations = {
  setUser: function setUser(state, user) {
    state.user = user;
  },
  setAccessExpiresIn: function setAccessExpiresIn(state, expire) {
    var now = Math.floor(Date.now() / 1000);
    now += expire;
    state.tokens.accessExpiresIn = now;
  },
  setOfflineMode: function setOfflineMode(state, status) {
    state.offlineMode = status;
    if (status) {
      state.tokens = {
        access: null,
        accessExpiresIn: null
      };
    }
  },
  clearUser: function clearUser(state, user) {
    state.user = false;
  },
  setAccessToken: function setAccessToken(state, token) {
    localStorage.setItem('accessToken', token);
    state.tokens.access = token;
  },
  clearAccessToken: function clearAccessToken(state) {
    localStorage.removeItem('accessToken');
    state.tokens.access = false;
  },
  setUrl: function setUrl(state, url) {
    state.url = url;
  },
  clearUrl: function clearUrl(state) {
    localStorage.removeItem('url');
    state.url = false;
  },

  // setRefreshToken(state, token) {
  //   localStorage.setItem('refreshToken', token);
  //   state.tokens.refresh = token;
  // },
  // clearRefreshToken(state) {
  //   localStorage.removeItem('refreshToken');
  //   state.tokens.refresh = false;
  // },
  setLoggedIn: function setLoggedIn(state, status) {
    state.loggedin = status;
  },
  loadOffline: function loadOffline(state, store) {
    state.showOtp = store.showOtp;
    state.loggedin = store.loggedin;
    state.user = store.user;
    state.tokens = store.tokens;
    state.url = store.url;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "DJir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon download-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "EZfu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Select2_vue__ = __webpack_require__("3fxR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_69ae3a53_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Select2_vue__ = __webpack_require__("FsKT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Select2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_69ae3a53_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Select2_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_69ae3a53_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Select2_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Faif":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthenticatorSettings_vue__ = __webpack_require__("A/5o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c8264aa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthenticatorSettings_vue__ = __webpack_require__("e9OB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthenticatorSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c8264aa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthenticatorSettings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c8264aa_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthenticatorSettings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ff5A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FjUE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ReloadIcon",
  props: {
    title: {
      type: String,
      default: "Reload icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "Fl5E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "HelpCircleIcon",
  props: {
    title: {
      type: String,
      default: "Help Circle icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "FsKT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('select',{staticClass:"form-control",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled}})])}
var staticRenderFns = []


/***/ }),

/***/ "Fx8p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ViewListIcon",
  props: {
    title: {
      type: String,
      default: "View List icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "Gf9n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H8AT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scrollbar"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col mt-2"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.post(_vm.form)}}},[_c('h1',[_vm._v("Settings")]),_vm._v(" "),(!_vm.offlineMode)?_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-link btn-sm auth-reload",attrs:{"typ":"button","disabled":_vm.fetching||!_vm.storeOffline},on:{"click":_vm.postPersonalPreferences }},[_c('upload-icon'),_vm._v("\n              Save settings and favorites to server "),(!_vm.storeOffline)?_c('span',[_vm._v("(Requires offline passphrase)")]):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-sm auth-reload",attrs:{"typ":"button","disabled":_vm.fetching||_vm.offlineMode},on:{"click":_vm.getPersonalPreferences}},[_c('download-icon'),_vm._v("\n              Import settings and favorites from server\n            ")],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-link btn-sm auth-reload",attrs:{"typ":"button","disabled":_vm.fetching},on:{"click":_vm.refreshAuthenticators}},[_c('reload-icon'),_vm._v("\n              Reload authenticators\n            ")],1)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Authenticators")]),_vm._v(" "),_c('div',{staticClass:"form-group pb-2"},[_c('div',{staticClass:"custom-control custom-checkbox float-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.advancedTemplate),expression:"form.advancedTemplate"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"advanced_template","disabled":_vm.offlineMode},domProps:{"checked":Array.isArray(_vm.form.advancedTemplate)?_vm._i(_vm.form.advancedTemplate,null)>-1:(_vm.form.advancedTemplate)},on:{"change":[function($event){var $$a=_vm.form.advancedTemplate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.form.advancedTemplate=$$a.concat([$$v]))}else{$$i>-1&&(_vm.form.advancedTemplate=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.form, "advancedTemplate", $$c)}},function($event){_vm.post(_vm.form)}]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"advanced_template"}},[_vm._v("Manual input")])]),_vm._v(" "),_c('label',{attrs:{"for":"template_id"}},[_vm._v("Authenticator template")]),_vm._v(" "),(!_vm.form.advancedTemplate)?_c('Select2',{attrs:{"id":"template_id","options":_vm.possibleAuthenticatorTemplates,"disabled":_vm.offlineMode,"settings":{}},on:{"change":function($event){_vm.post(_vm.form)}},model:{value:(_vm.form.templateId),callback:function ($$v) {_vm.$set(_vm.form, "templateId", $$v)},expression:"form.templateId"}}):_vm._e(),_vm._v(" "),(_vm.form.advancedTemplate)?_c('span',{staticClass:"alert alert-info mb-0 mt-2 d-block"},[_vm._v("Need help\n                              "),_c('router-link',{staticClass:"btn-link",attrs:{"to":"/help"}},[_vm._v("how to configure secret server")]),_vm._v("?\n                          ")],1):_vm._e(),_vm._v(" "),(_vm.form.advancedTemplate)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.templateId),expression:"form.templateId"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1","id":"template_id","disabled":_vm.offlineMode},domProps:{"value":(_vm.form.templateId)},on:{"change":function($event){_vm.post(_vm.form)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "templateId", $event.target.value)}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group pb-2"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.show),expression:"form.show"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"show_otp"},domProps:{"checked":Array.isArray(_vm.form.show)?_vm._i(_vm.form.show,null)>-1:(_vm.form.show)},on:{"change":[function($event){var $$a=_vm.form.show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.form.show=$$a.concat([$$v]))}else{$$i>-1&&(_vm.form.show=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.form, "show", $$c)}},function($event){_vm.post(_vm.form)}]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"show_otp"}},[_vm._v("Always show One Time Passwords")])])]),_vm._v(" "),(!_vm.showAdvanced)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleShowAdvanced}},[_vm._v("Show advanced template\n            configuration")]):_vm._e(),_vm._v(" "),(_vm.showAdvanced)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleShowAdvanced}},[_vm._v("Hide advanced template configuration")]):_vm._e(),_vm._v(" "),(_vm.showAdvanced)?_c('div',{staticClass:"card-body border"},[_c('a',{staticClass:"btn btn-sm btn-link float-right ml-2",attrs:{"href":"#"},on:{"click":_vm.resetTemplateFilter}},[_vm._v("Reset\n              to default")]),_vm._v(" "),_c('p',[_vm._v("Terms used to match possible authenticator secret templates:")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.newTemplateFilter),expression:"form.newTemplateFilter"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.newTemplateFilter)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.postTemplateFilter($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "newTemplateFilter", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":_vm.postTemplateFilter}},[_vm._v("\n                  Add term\n                ")])])]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush mb-5"},_vm._l((_vm.filterTemplateOn),function(option,i){return _c('li',{staticClass:"list-group-item px-0"},[_vm._v("\n                "+_vm._s(option)+" "),_c('a',{staticClass:"btn-link float-right",attrs:{"href":"#"},on:{"click":function($event){_vm.removeTemplateFilter(i)}}},[_vm._v("remove")])])})),_vm._v(" "),(!_vm.filterTemplateOn)?_c('span',{staticClass:"alert alert-danger"},[_vm._v("No terms defined - requires at least one term in order to function")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-link float-right ml-2",attrs:{"href":"#"},on:{"click":_vm.resetFieldFilter}},[_vm._v("Reset to\n              default")]),_vm._v(" "),_c('p',[_vm._v("Terms used to match the secret's field which is used to generate the One Time\n              Passwords.")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.newFieldFilter),expression:"form.newFieldFilter"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.newFieldFilter)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.postFieldFilter($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "newFieldFilter", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":_vm.postFieldFilter}},[_vm._v("\n                  Add term\n                ")])])]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((_vm.filterFieldOn),function(option,i){return _c('li',{staticClass:"list-group-item px-0"},[_vm._v("\n                "+_vm._s(option)+" "),_c('a',{staticClass:"btn-link float-right",attrs:{"href":"#"},on:{"click":function($event){_vm.removeFieldFilter(i)}}},[_vm._v("remove")])])})),_vm._v(" "),(!_vm.filterFieldOn)?_c('span',{staticClass:"alert alert-danger"},[_vm._v("No terms defined - requires at least one term in order to function")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Offline-settings")]),_vm._v(" "),_c('p',[_vm._v("\n            Store the data offline encrypted by a password of your choosing. If disabled, your session\n            is limited to\n            20 minutes and you will be logged out after expiration.")]),_vm._v(" "),(_vm.hasOfflineStore)?_c('button',{staticClass:"btn btn-outline-secondary ml-3 float-right",attrs:{"type":"button"},on:{"click":_vm.deleteOfflineStore}},[_vm._v("× Clear Offline Data\n          ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n            Please note, whilst in offline mode it is not possible to retrieve new data without going\n            online\n            first.")]),_vm._v(" "),_c('div',{staticClass:"form-group pb-2"},[_c('label',{attrs:{"for":"offline_key"}},[_vm._v("Offline passphrase")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.newKey),expression:"form.newKey"}],staticClass:"form-control",attrs:{"type":"password","id":"offline_key"},domProps:{"value":(_vm.form.newKey)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.storeNewEncryptKey($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "newKey", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button","id":"button-addon2"},on:{"click":_vm.storeNewEncryptKey}},[_vm._v("\n                  Enable offline store with passphrase\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group pb-2"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.offline),expression:"form.offline"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","disabled":!_vm.form.offline,"id":"offline"},domProps:{"checked":Array.isArray(_vm.form.offline)?_vm._i(_vm.form.offline,null)>-1:(_vm.form.offline)},on:{"change":[function($event){var $$a=_vm.form.offline,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.form.offline=$$a.concat([$$v]))}else{$$i>-1&&(_vm.form.offline=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.form, "offline", $$c)}},function($event){_vm.post(_vm.form)}]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"offline"}},[_vm._v("Store offline\n                "),(_vm.form.offline)?_c('small',[_vm._v("(disabling this will remove any offline stored data)\n                ")]):_vm._e()])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Looking for more?")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{staticClass:"btn-link",attrs:{"href":"#"},on:{"click":_vm.showPrivacy}},[_vm._v("\n              Privacy Policy\n            ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"btn-link",attrs:{"href":"#"},on:{"click":_vm.showDisclaimer}},[_vm._v("\n              Disclaimer\n            ")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"btn-link",attrs:{"href":"#"},on:{"click":_vm.showHelp}},[_vm._v("\n              Help\n            ")])])]),_vm._v(" "),_vm._m(0,false,false)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center mb-2"},[_c('small',[_vm._v("v1.2.1.1")])])}]


/***/ }),

/***/ "I5CX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_event_hub__ = __webpack_require__("B6dM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_design_icons_ArrowLeft__ = __webpack_require__("7TVh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_CloudOffOutline__ = __webpack_require__("X6HY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_Reload__ = __webpack_require__("qTl2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_Download__ = __webpack_require__("NMje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_Upload__ = __webpack_require__("Lsay");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_OpenInNew__ = __webpack_require__("JtXI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_HelpCircle__ = __webpack_require__("f7RK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr__ = __webpack_require__("vQJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_material_design_icons_Settings__ = __webpack_require__("YRA+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_material_design_icons_Security__ = __webpack_require__("67Oy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_material_design_icons_ViewList__ = __webpack_require__("iI3b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_material_design_icons_Alert__ = __webpack_require__("UCAU");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















__WEBPACK_IMPORTED_MODULE_10_toastr__["options"].timeout = 1500;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings-list',
  components: {
    AlertIcon: __WEBPACK_IMPORTED_MODULE_14_vue_material_design_icons_Alert__["a" /* default */],
    ViewListIcon: __WEBPACK_IMPORTED_MODULE_13_vue_material_design_icons_ViewList__["a" /* default */],
    SecurityIcon: __WEBPACK_IMPORTED_MODULE_12_vue_material_design_icons_Security__["a" /* default */],
    SettingsIcon: __WEBPACK_IMPORTED_MODULE_11_vue_material_design_icons_Settings__["a" /* default */],
    HelpCircleIcon: __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_HelpCircle__["a" /* default */],
    OpenInNewIcon: __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_OpenInNew__["a" /* default */],
    UploadIcon: __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_Upload__["a" /* default */],
    DownloadIcon: __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_Download__["a" /* default */],
    ReloadIcon: __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_Reload__["a" /* default */],
    CloudOffOutlineIcon: __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_CloudOffOutline__["a" /* default */],
    ArrowLeftIcon: __WEBPACK_IMPORTED_MODULE_3_vue_material_design_icons_ArrowLeft__["a" /* default */]
  },
  data: function data() {
    return {
      fetching: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    offlineMode: 'auth/offlineMode',
    user: 'auth/user',
    authenticators: 'authenticators/all',
    filterTemplateOn: 'authenticators/filterTemplateOn',
    personalFolderId: 'authenticators/personalFolderId',
    filterFieldOn: 'authenticators/filterFieldOn',
    secrettemplates: 'secretTemplates/all',
    getTemplateById: 'secretTemplates/getById',
    templateId: 'authenticators/templateId',
    showOtp: 'settings/showOtp',
    okey: 'settings/okey',
    advancedTemplate: 'settings/advancedTemplate',
    storeOffline: 'settings/storeOffline',
    url: 'auth/url',
    favorites: 'authenticators/favorites',
    settingsId: 'authenticators/settingsId'
  }), {
    version: function version() {
      return "1.2.3";
    },
    settingsUrl: function settingsUrl() {
      if (this.settingsId) {
        return this.url + '/SecretView.aspx?secretid=' + this.settingsId;
      }
      return '#';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    addFieldFilter: 'authenticators/addFieldFilter',
    addTemplateFilter: 'authenticators/addTemplateFilter',
    removeFieldFilter: 'authenticators/removeFieldFilter',
    removeTemplateFilter: 'authenticators/removeTemplateFilter',
    resetTemplateFilter: 'authenticators/resetTemplateFilter',
    resetFieldFilter: 'authenticators/resetFieldFilter',
    postSecret: 'authenticators/postSecret',
    getStub: 'authenticators/getStub',
    postPreferences: 'authenticators/postPreferences',
    getPreferences: 'authenticators/getPreferences',
    putSecret: 'authenticators/putSecret',
    getSecret: 'authenticators/getSecret',
    getPersonalFolderId: 'authenticators/getPersonalFolderId',
    patchSecretField: 'authenticators/patchSecretField'
  }), {
    previous: function previous() {
      this.$router.push({ name: 'authenticators' });
    },
    showHelp: function showHelp() {
      __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$emit('help-show');
    },
    showDisclaimer: function showDisclaimer() {
      __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$emit('disclaimer-show');
    },
    showPrivacy: function showPrivacy() {
      __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$emit('privacy-show');
    },
    postPersonalPreferences: function postPersonalPreferences(e) {
      var _this = this;

      e.preventDefault();
      if (!this.offlineMode && this.personalFolderId) {

        this.fetching = true;
        this.postPreferences().then(function (response) {
          if (typeof response == "undefined") {
            return __WEBPACK_IMPORTED_MODULE_10_toastr__["error"]('Unable to save settings.');
          }
          return __WEBPACK_IMPORTED_MODULE_10_toastr__["success"]('Settings and favorites saved.');
        }).catch(function () {
          return __WEBPACK_IMPORTED_MODULE_10_toastr__["error"]('Unable to save settings.');
        }).finally(function () {
          _this.fetching = false;
        });
      }
    },
    getPersonalPreferences: function getPersonalPreferences(e) {
      var _this2 = this;

      e.preventDefault();

      if (!this.offlineMode) {
        this.fetching = true;
        this.getPreferences(true).then(function (result) {
          if (result == 0) {
            return __WEBPACK_IMPORTED_MODULE_10_toastr__["info"]('No settings found.');
          }
          if (typeof result !== 'undefined' && result >= 1) {
            return __WEBPACK_IMPORTED_MODULE_10_toastr__["success"]('Settings and favorites loaded.');
          }
        }).finally(function () {
          _this2.fetching = false;
        });
      }
    }
  }),
  mounted: function mounted() {
    if (!this.personalFolderId) {
      this.getPersonalFolderId();
    }
  }
});

/***/ }),

/***/ "IToN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iw6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SecurityIcon",
  props: {
    title: {
      type: String,
      default: "Security icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "JDWr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon help-circle-outline-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M11,18H13V16H11V18M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6C9.79,6 8,7.79 8,10H10C10,8.9 10.9,8 12,8C13.1,8 14,8.9 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10C16,7.79 14.21,6 12,6Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JtXI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OpenInNew_vue__ = __webpack_require__("qRqY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7ebd6a6a_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_OpenInNew_vue__ = __webpack_require__("2AGJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_OpenInNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7ebd6a6a_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_OpenInNew_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7ebd6a6a_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_OpenInNew_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JxEu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon delete-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19C6,20.1 6.9,21 8,21H16C17.1,21 18,20.1 18,19V7H6V19Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "K1kK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Star_vue__ = __webpack_require__("OLjE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e757406_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Star_vue__ = __webpack_require__("PGWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Star_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e757406_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Star_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e757406_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Star_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KEYh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HelpCircleOutline_vue__ = __webpack_require__("Uu7A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50bc1ace_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_HelpCircleOutline_vue__ = __webpack_require__("JDWr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HelpCircleOutline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50bc1ace_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_HelpCircleOutline_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50bc1ace_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_HelpCircleOutline_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kl9A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon close-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "Lns1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var state = {
  appLoading: true,
  loading: false
};

var getters = {
  isLoading: function isLoading() {
    return state.loading;
  },
  isAppLoading: function isAppLoading() {
    return state.appLoading;
  }
};

var actions = {
  setLoading: function setLoading(_ref, status) {
    var commit = _ref.commit;

    commit('setLoading', status);
  },
  setAppLoading: function setAppLoading(_ref2, status) {
    var commit = _ref2.commit;

    commit('setAppLoading', status);
  }
};

var mutations = {
  setLoading: function setLoading(state, status) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'loading', status);
  },
  setAppLoading: function setAppLoading(state, status) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state, 'appLoading', status);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Lsay":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Upload_vue__ = __webpack_require__("cL2p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_72baeccc_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Upload_vue__ = __webpack_require__("ePdZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_72baeccc_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Upload_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_72baeccc_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Upload_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc70ee44_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("nyoq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Qi+p")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc70ee44_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc70ee44_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MV//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__("503v");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e151b7c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__("YqEc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e151b7c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e151b7c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__interceptors_Jwt__ = __webpack_require__("2xDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_css_mdb_css__ = __webpack_require__("xBry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__build_css_mdb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__build_css_mdb_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_material_design_icons_styles_css__ = __webpack_require__("siN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_material_design_icons_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_material_design_icons_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_toastr_build_toastr_css__ = __webpack_require__("IToN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_toastr_build_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_toastr_build_toastr_css__);









var keySize = 256;
var iterations = 100;

var encrypt = function encrypt(msg, pass) {
  var salt = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.lib.WordArray.random(128 / 8);
  var key = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.PBKDF2(pass, salt, {
    keySize: keySize / 32,
    iterations: iterations
  });
  var iv = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.lib.WordArray.random(128 / 8);
  var encrypted = __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.AES.encrypt(msg, key, {
    iv: iv,
    padding: __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.pad.Pkcs7,
    mode: __WEBPACK_IMPORTED_MODULE_5_crypto_js___default.a.mode.CBC
  });
  var transitmessage = salt.toString() + iv.toString() + encrypted.toString();
  return transitmessage;
};



var writeStore = __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default()(function (state, key) {
  var toEncrypt = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    auth: state.auth,
    settings: state.settings,
    authenticators: state.authenticators,
    secretTemplates: state.secretTemplates
  });
  localStorage.setItem('store', encrypt(toEncrypt, key));
}, 200, { maxWait: 1000 });

__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */].subscribe(function (mutation, state) {
  if (__WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */].getters['auth/loggedin'] && __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */].getters['settings/okey']) {
    var okey = __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */].getters['settings/okey'];
    if (okey) {
      writeStore(state, okey);
    }
  }
});









__WEBPACK_IMPORTED_MODULE_7_axios___default.a.interceptors.request.use(__WEBPACK_IMPORTED_MODULE_8__interceptors_Jwt__["b" /* beforeRequestSuccess */], __WEBPACK_IMPORTED_MODULE_8__interceptors_Jwt__["a" /* beforeRequestError */]);
__WEBPACK_IMPORTED_MODULE_7_axios___default.a.interceptors.response.use(__WEBPACK_IMPORTED_MODULE_8__interceptors_Jwt__["d" /* onSuccess */], __WEBPACK_IMPORTED_MODULE_8__interceptors_Jwt__["c" /* onError */]);

// Vue.config.productionTip = false;
// Vue.config.devtools = true;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NMje":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Download_vue__ = __webpack_require__("gq7E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_664cd29b_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Download_vue__ = __webpack_require__("DJir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Download_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_664cd29b_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Download_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_664cd29b_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Download_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NxGh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("8taH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_175465df_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("xqmF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Ff5A")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-175465df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_175465df_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_175465df_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OLjE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "StarIcon",
  props: {
    title: {
      type: String,
      default: "Star icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "OMbd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EyeOffIcon",
  props: {
    title: {
      type: String,
      default: "Eye Off icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "OZEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__("8aDi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58a48130_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__("slAo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Gf9n")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58a48130"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58a48130_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58a48130_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Oluc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PGWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon star-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "QDar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_event_hub__ = __webpack_require__("B6dM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_toastr__ = __webpack_require__("vQJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_v_select2_component__ = __webpack_require__("EZfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_Delete__ = __webpack_require__("02d3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_Reload__ = __webpack_require__("qTl2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_Download__ = __webpack_require__("NMje");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_material_design_icons_Upload__ = __webpack_require__("Lsay");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__WEBPACK_IMPORTED_MODULE_4_toastr__["options"].timeout = 1500;
var keySize = 256;
var iterations = 100;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Settings',
  components: {
    UploadIcon: __WEBPACK_IMPORTED_MODULE_10_vue_material_design_icons_Upload__["a" /* default */],
    DownloadIcon: __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_Download__["a" /* default */],
    ReloadIcon: __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_Reload__["a" /* default */],
    Select2: __WEBPACK_IMPORTED_MODULE_5_v_select2_component__["a" /* default */],
    DeleteIcon: __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_Delete__["a" /* default */]
  },
  data: function data() {
    return {
      form: {
        dispatched: {},
        fieldId: false,
        templateId: false,
        advancedTemplate: false,
        show: false,
        offline: false,
        newKey: '',
        newTemplateFilter: '',
        filterTemplateOn: ["auth"],
        newFieldFilter: '',
        filterFieldOn: ["restorecode", "authcode"]
      },
      fetching: false,
      showAdvanced: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])({
    offlineMode: 'auth/offlineMode',
    user: 'auth/user',
    authenticators: 'authenticators/all',
    filterTemplateOn: 'authenticators/filterTemplateOn',
    personalFolderId: 'authenticators/personalFolderId',
    filterFieldOn: 'authenticators/filterFieldOn',
    secrettemplates: 'secretTemplates/all',
    getTemplateById: 'secretTemplates/getById',
    templateId: 'authenticators/templateId',
    showOtp: 'settings/showOtp',
    okey: 'settings/okey',
    advancedTemplate: 'settings/advancedTemplate',
    storeOffline: 'settings/storeOffline',
    url: 'auth/url',
    favorites: 'authenticators/favorites'
  }), {
    template: function template() {
      if (this.templateId) {
        return this.getTemplateById(this.templateId);
      }
      return false;
    },
    hasOfflineStore: function hasOfflineStore() {
      if (localStorage.getItem('store') === null) {
        return false;
      }
      return true;
    },
    possibleAuthenticatorTemplates: function possibleAuthenticatorTemplates() {
      var _this = this;

      if (this.secrettemplates) {
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.secrettemplates, function (template) {
          var name = _this.multiIncludes(template.text, _this.filterTemplateOn);

          if (name) {
            return true;
          }
        });
      }
      return false;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])({
    addFieldFilter: 'authenticators/addFieldFilter',
    addTemplateFilter: 'authenticators/addTemplateFilter',
    removeFieldFilter: 'authenticators/removeFieldFilter',
    removeTemplateFilter: 'authenticators/removeTemplateFilter',
    resetTemplateFilter: 'authenticators/resetTemplateFilter',
    resetFieldFilter: 'authenticators/resetFieldFilter',
    postSecret: 'authenticators/postSecret',
    getStub: 'authenticators/getStub',
    postPreferences: 'authenticators/postPreferences',
    getPreferences: 'authenticators/getPreferences',
    putSecret: 'authenticators/putSecret',
    getSecret: 'authenticators/getSecret',
    getPersonalFolderId: 'authenticators/getPersonalFolderId',
    patchSecretField: 'authenticators/patchSecretField'
  }), {
    showHelp: function showHelp() {
      __WEBPACK_IMPORTED_MODULE_2__events_event_hub__["a" /* default */].$emit('help-show');
    },
    showDisclaimer: function showDisclaimer() {
      __WEBPACK_IMPORTED_MODULE_2__events_event_hub__["a" /* default */].$emit('disclaimer-show');
    },
    showPrivacy: function showPrivacy() {
      __WEBPACK_IMPORTED_MODULE_2__events_event_hub__["a" /* default */].$emit('privacy-show');
    },
    postPersonalPreferences: function postPersonalPreferences(e) {
      var _this2 = this;

      e.preventDefault();
      if (!this.offlineMode && this.personalFolderId) {

        this.fetching = true;
        this.postPreferences().then(function (response) {
          if (typeof response == "undefined") {
            return __WEBPACK_IMPORTED_MODULE_4_toastr__["error"]('Unable to save settings.');
          }
          return __WEBPACK_IMPORTED_MODULE_4_toastr__["success"]('Settings and favorites saved.');
        }).catch(function () {
          return __WEBPACK_IMPORTED_MODULE_4_toastr__["error"]('Unable to save settings.');
        }).finally(function () {
          _this2.fetching = false;
        });
      }
    },
    refreshAuthenticators: function refreshAuthenticators(e) {
      var _this3 = this;

      e.preventDefault();
      this.fetching = true;
      this.$store.dispatch('authenticators/clearAll');
      this.$store.dispatch('asyncData').then(function () {
        return __WEBPACK_IMPORTED_MODULE_4_toastr__["success"]('Authenticators retrieved.');
      }).catch(function () {
        return __WEBPACK_IMPORTED_MODULE_4_toastr__["error"]('Unable to fetch authenticators.');
      }).finally(function () {
        _this3.fetching = false;
      });
    },
    getPersonalPreferences: function getPersonalPreferences(e) {
      var _this4 = this;

      e.preventDefault();

      if (!this.offlineMode && this.personalFolderId) {
        this.fetching = true;
        this.getPreferences(true).then(function (result) {
          if (result == 0) {
            return __WEBPACK_IMPORTED_MODULE_4_toastr__["info"]('No settings found.');
          }
          if (typeof result !== 'undefined' && result >= 1) {
            _this4.form.offline = true;
            return __WEBPACK_IMPORTED_MODULE_4_toastr__["success"]('Settings and favorites loaded.');
          }
        }).finally(function () {

          _this4.fetching = false;
        });
      }
    },
    toggleShowAdvanced: function toggleShowAdvanced() {
      this.showAdvanced = !this.showAdvanced;
    },
    postTemplateFilter: function postTemplateFilter() {
      if (this.form.newTemplateFilter !== '') {
        this.addTemplateFilter(this.form.newTemplateFilter);
        this.form.newTemplateFilter = '';
      }
    },
    postFieldFilter: function postFieldFilter() {
      if (this.form.newFieldFilter !== '') {
        this.addFieldFilter(this.form.newFieldFilter);
        this.form.newFieldFilter = '';
      }
    },
    deleteOfflineStore: function deleteOfflineStore() {
      if (confirm("Do you want to remove your offline data?")) {
        // eslint-disable-line no-alert
        this.form.offline = false;
        this.$store.commit('settings/setOkey', null);
        this.post(this.form);
      }
    },
    post: function post(form) {
      if (!this.offlineMode) {

        if (this.form.templateId) {
          this.$store.commit('authenticators/setTemplateId', this.form.templateId);
        }

        this.$store.commit('settings/setAdvancedTemplate', this.form.advancedTemplate);
      }

      this.$store.commit('settings/setShowOtp', this.form.show);

      this.$store.commit('settings/setStoreOffline', this.form.offline);

      if (!this.form.offline) {
        localStorage.removeItem('store');
      }

      __WEBPACK_IMPORTED_MODULE_4_toastr__["success"]('Settings saved');
    },
    multiIncludes: function multiIncludes(text, values) {
      var re = new RegExp(values.join('|'), 'i');
      return re.test(text);
    },
    storeNewEncryptKey: function storeNewEncryptKey() {
      if (this.form.newKey !== '') {
        // let key = this.encrypt(this.form.newKey, this.form.newKey);
        this.$store.commit('settings/setStoreOffline', true);
        this.$store.commit('settings/setOkey', this.form.newKey);
        this.form.newKey = '';
        this.form.offline = true;
        __WEBPACK_IMPORTED_MODULE_4_toastr__["success"]('Storing encrypted data offline is enabled.');
      }
    },
    encrypt: function encrypt(msg) {
      var pass = this.okey;
      var salt = __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.lib.WordArray.random(128 / 8);

      var key = __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.PBKDF2(pass, salt, {
        keySize: keySize / 32,
        iterations: iterations
      });

      var iv = __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.lib.WordArray.random(128 / 8);

      var encrypted = __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.AES.encrypt(msg, key, {
        iv: iv,
        padding: __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.pad.Pkcs7,
        mode: __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.mode.CBC
      });

      // salt, iv will be hex 32 in length
      // append them to the ciphertext for use  in decryption
      var transitmessage = salt.toString() + iv.toString() + encrypted.toString();
      return transitmessage;
    },
    decrypt: function decrypt(transitmessage, pass) {
      var salt = __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.enc.Hex.parse(transitmessage.substr(0, 32));
      var iv = __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.enc.Hex.parse(transitmessage.substr(32, 32));
      var encrypted = transitmessage.substring(64);

      var key = __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.PBKDF2(pass, salt, {
        keySize: keySize / 32,
        iterations: iterations
      });

      var decrypted = __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.AES.decrypt(encrypted, key, {
        iv: iv,
        padding: __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.pad.Pkcs7,
        mode: __WEBPACK_IMPORTED_MODULE_6_crypto_js___default.a.mode.CBC

      });
      return decrypted;
    }
  }),
  mounted: function mounted() {
    var _this5 = this;

    if (this.templateId) {
      this.form.templateId = this.templateId;
    }
    if (this.fieldId) {
      this.form.fieldId = this.fieldId;
    }
    if (this.showOtp) {
      this.form.show = this.showOtp;
    }
    if (this.storeOffline) {
      this.form.offline = this.storeOffline;
      localStorage.removeItem('store');
    }
    if (this.advancedTemplate) {
      this.form.advancedTemplate = this.advancedTemplate;
    }
    if (this.filterFieldOn) {
      this.form.filterFieldOn = this.filterFieldOn;
    }
    if (!this.offlineMode) {
      this.$store.dispatch('secretTemplates/getSecretTemplates').catch(function (e) {
        if (e.status == 400 && e.data.errorCode === "API_AccessDenied") {
          _this5.form.advancedTemplate = true;
        }
      });
    }
  }
});

/***/ }),

/***/ "QHWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon settings-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M12,15.5C10.07,15.5 8.5,13.93 8.5,12C8.5,10.07 10.07,8.5 12,8.5C13.93,8.5 15.5,10.07 15.5,12C15.5,13.93 13.93,15.5 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "Qi+p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RIGl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SecurityClose_vue__ = __webpack_require__("vReH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_71101596_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_SecurityClose_vue__ = __webpack_require__("dTkO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_SecurityClose_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_71101596_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_SecurityClose_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_71101596_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_SecurityClose_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RumR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon content-copy-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M19,21H8V7H19M19,5H8C6.9,5 6,5.9 6,7V21C6,22.1 6.9,23 8,23H19C20.1,23 21,22.1 21,21V7C21,5.9 20.1,5 19,5M16,1H4C2.9,1 2,1.9 2,3V17H4V3H16V1Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "T6uP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item list-group-item-action auth",class:{'purple-text' : (!_vm.secret.items) },attrs:{"id":'cl-'+_vm.secret.id},on:{"click":function($event){_vm.copy(_vm.secret.id)}}},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('p',{staticClass:"auth-name"},[_vm._v(_vm._s(_vm.secret.name))]),_vm._v(" "),(_vm.favoriteFeature)?_c('button',{staticClass:"auth-fav",attrs:{"disabled":!_vm.canFavorite,"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.favorite($event)}}},[(!_vm.favorited)?_c('star-outline-icon'):_vm._e(),_vm._v(" "),(_vm.favorited)?_c('star-icon'):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.secret.items)?_c('loading-icon',{staticClass:"spin"}):_vm._e(),_vm._v(" "),(_vm.secret.items)?_c('a',{staticClass:"auth-ext",attrs:{"href":_vm.secretUrl(_vm.secret.id),"target":"_blank"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("Open\n      "),_c('open-in-new-icon')],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"id":'as-'+_vm.secret.id,"type":_vm.fieldType(_vm.secret.id),"disabled":"disabled"},domProps:{"value":_vm.mask}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[(!_vm.alwaysShowOtp)?_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.toggleShowOtp(_vm.secret.id)}}},[(!_vm.showOtp)?_c('span',[_c('eye-icon')],1):_vm._e(),_vm._v(" "),(_vm.showOtp)?_c('span',[_c('eye-off-icon')],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.copy(_vm.secret.id)}}},[_c('content-copy-icon')],1)])]),_vm._v(" "),_c('span',{staticClass:"chip",class:{'white-text' : (_vm.time <= 5), 'orange' : (_vm.time <= 5 && _vm.time >= 3), 'red' : (_vm.time <= 2),}},[_vm._v(_vm._s(_vm.time))])])}
var staticRenderFns = []


/***/ }),

/***/ "THyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto_js__);


var state = {
  showOtp: false,
  storeOffline: false,
  okey: false,
  advancedTemplate: false,
  domain: false
};

var getters = {
  showOtp: function showOtp() {
    return state.showOtp;
  },
  storeOffline: function storeOffline() {
    return state.storeOffline;
  },
  okey: function okey() {
    return state.okey;
  },
  advancedTemplate: function advancedTemplate() {
    return state.advancedTemplate;
  },
  domain: function domain() {
    return state.domain;
  }
};

var actions = {
  setShowOtp: function setShowOtp(_ref, payload) {
    var commit = _ref.commit;

    return commit('setShowOtp', payload);
  },
  setOkey: function setOkey(_ref2, payload) {
    var commit = _ref2.commit;

    return commit('setOkey', payload);
  },
  setStoreOffline: function setStoreOffline(_ref3, payload) {
    var commit = _ref3.commit;

    return commit('setStoreOffline', payload);
  },
  setAdvancedTemplate: function setAdvancedTemplate(_ref4, payload) {
    var commit = _ref4.commit;

    return commit('setAdvancedTemplate', payload);
  },
  setDomain: function setDomain(_ref5, payload) {
    var commit = _ref5.commit;

    return commit('setDomain', payload);
  },
  clearState: function clearState(_ref6) {
    var commit = _ref6.commit;

    return commit('clearState');
  }
};

var mutations = {
  clearState: function clearState(state) {
    state.showOtp = false;
    state.storeOffline = false;
    state.okey = false;
    state.advancedTemplate = false;
    state.domain = false;
  },
  setOkey: function setOkey(state, payload) {
    state.okey = payload;
  },
  encryptOkey: function encryptOkey(state, payload) {
    state.okey = __WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.SHA512(payload + state.domain).toString(__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Hex);
  },
  setDomain: function setDomain(state, payload) {
    state.domain = payload.toLowerCase();
  },
  setShowOtp: function setShowOtp(state, status) {
    state.showOtp = status;
    localStorage.setItem('showOtp', status);
  },
  setStoreOffline: function setStoreOffline(state, status) {
    state.storeOffline = status;
    if (!status) {
      state.okey = null;
    }
  },
  setAdvancedTemplate: function setAdvancedTemplate(state, status) {
    state.advancedTemplate = status;
    localStorage.setItem('advancedTemplate', status);
  },
  loadOffline: function loadOffline(state, store) {
    state.showOtp = store.showOtp;
    state.storeOffline = store.storeOffline;
    state.okey = store.okey;
    state.advancedTemplate = store.advancedTemplate;
    state.domain = store.domain;
  },
  setLoggedIn: function setLoggedIn(state, status) {
    state.loggedin = status;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Tf+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EyeIcon",
  props: {
    title: {
      type: String,
      default: "Eye icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "UCAU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Alert_vue__ = __webpack_require__("vaww");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0958dbd9_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Alert_vue__ = __webpack_require__("6eES");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0958dbd9_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Alert_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0958dbd9_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Alert_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Uu7A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "HelpCircleOutlineIcon",
  props: {
    title: {
      type: String,
      default: "Help Circle Outline icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "Vi6C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon security-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M12,12H19C18.47,16.11 15.72,19.78 12,20.92V12H5V6.3L12,3.19M12,1L3,5V11C3,16.55 6.84,21.73 12,23C17.16,21.73 21,16.55 21,11V5L12,1Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "VrdI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_event_hub__ = __webpack_require__("B6dM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'disclaimer',
  data: function data() {
    return {
      active: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    loggedin: 'auth/loggedin'
  })),
  methods: {
    hide: function hide() {
      this.active = false;
    },
    show: function show() {
      this.active = true;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$on('disclaimer-show', this.show);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$off('disclaimer-show');
  }
});

/***/ }),

/***/ "W3tM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__("wtEF");


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].getters['auth/loggedin']) {
    __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* default */].dispatch('auth/logout');
    return next('/login');
  }

  // if (to.meta.isAdmin === "undefined" || !to.meta.isAdmin) {
  //   return next();
  // }

  // @TODO: Permissions ?
  // if (!store.getters['auth/isAdmin']) {
  //   store.dispatch('feedback/setDelayedFeedback',
  //     {feedback: {message: 'You are not authorized to access this restricted area', type: 'danger'}}
  //   );
  //   return next('/');
  // }

  return next();
});

/***/ }),

/***/ "WGpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_event_hub__ = __webpack_require__("B6dM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__("vQJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_Delete__ = __webpack_require__("02d3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_ArrowLeft__ = __webpack_require__("7TVh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_CloudOffOutline__ = __webpack_require__("X6HY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_SecurityClose__ = __webpack_require__("RIGl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_CheckboxMarked__ = __webpack_require__("kyAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_CheckboxMarkedOutline__ = __webpack_require__("3wPs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_material_design_icons_CloudOutline__ = __webpack_require__("cJ9L");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__WEBPACK_IMPORTED_MODULE_3_toastr__["options"].timeout = 1500;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'offline-settings',
  components: {
    CloudOutlineIcon: __WEBPACK_IMPORTED_MODULE_10_vue_material_design_icons_CloudOutline__["a" /* default */],
    CheckboxMarkedOutlineIcon: __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_CheckboxMarkedOutline__["a" /* default */],
    CheckboxMarkedIcon: __WEBPACK_IMPORTED_MODULE_8_vue_material_design_icons_CheckboxMarked__["a" /* default */],
    SecurityCloseIcon: __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_SecurityClose__["a" /* default */],
    CloudOffOutlineIcon: __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_CloudOffOutline__["a" /* default */],
    ArrowLeftIcon: __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_ArrowLeft__["a" /* default */],
    DeleteIcon: __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_Delete__["a" /* default */]
  },
  data: function data() {
    return {
      newKey: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    offlineMode: 'auth/offlineMode',
    okey: 'settings/okey'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    logout: 'auth/logout',
    setOfflineMode: 'auth/setOfflineMode'
  }), {
    switchToOffline: function switchToOffline() {
      if (confirm("Enabling offline-mode will disable retrieving new authenticators, settings or storing your preferences. Are yous sure?")) {
        // eslint-disable-line no-alert
        this.setOfflineMode(true);
      }
    },
    logoutUser: function logoutUser() {
      var _this = this;

      this.logout().then(function () {
        _this.$router.push({ name: 'login', query: { in: 1 } });
        //return document.location.reload();
      });
    },
    previous: function previous() {
      return this.$router.push({ name: 'settings' });
    },
    showHelp: function showHelp() {
      __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$emit('help-show');
    },
    showDisclaimer: function showDisclaimer() {
      __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$emit('disclaimer-show');
    },
    showPrivacy: function showPrivacy() {
      __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$emit('privacy-show');
    },
    postPersonalPreferences: function postPersonalPreferences(e) {
      var _this2 = this;

      e.preventDefault();
      if (!this.offlineMode && this.personalFolderId) {

        this.fetching = true;
        this.postPreferences().then(function (response) {
          if (typeof response == "undefined") {
            return __WEBPACK_IMPORTED_MODULE_3_toastr__["error"]('Unable to save settings.');
          }
          return __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Settings and favorites saved.');
        }).catch(function () {
          return __WEBPACK_IMPORTED_MODULE_3_toastr__["error"]('Unable to save settings.');
        }).finally(function () {
          _this2.fetching = false;
        });
      }
    },
    refreshAuthenticators: function refreshAuthenticators(e) {
      var _this3 = this;

      e.preventDefault();
      this.fetching = true;
      this.$store.dispatch('authenticators/clearAll');
      this.$store.dispatch('asyncData').then(function () {
        return __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Authenticators retrieved.');
      }).catch(function () {
        return __WEBPACK_IMPORTED_MODULE_3_toastr__["error"]('Unable to fetch authenticators.');
      }).finally(function () {
        _this3.fetching = false;
      });
    },
    getPersonalPreferences: function getPersonalPreferences(e) {
      var _this4 = this;

      e.preventDefault();

      if (!this.offlineMode && this.personalFolderId) {
        this.fetching = true;
        this.getPreferences(true).then(function (result) {
          if (result == 0) {
            return __WEBPACK_IMPORTED_MODULE_3_toastr__["info"]('No settings found.');
          }
          if (typeof result !== 'undefined' && result >= 1) {
            _this4.form.offline = true;
            return __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Settings and favorites loaded.');
          }
        }).finally(function () {

          _this4.fetching = false;
        });
      }
    },
    deleteOfflineStore: function deleteOfflineStore() {
      if (confirm("Do you want to remove your offline data?")) {
        // eslint-disable-line no-alert
        this.$store.commit('settings/setOkey', null);
        this.$store.commit('settings/setStoreOffline', false);
        localStorage.removeItem('store');
        if (!this.okey) {
          if (this.offlineMode) {
            this.logoutUser();
          }
          __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Store and offline key removed');
        }
      }
    },
    storeNewEncryptKey: function storeNewEncryptKey() {
      if (this.newKey !== '') {
        this.$store.commit('settings/setStoreOffline', true);
        this.$store.commit('settings/encryptOkey', this.newKey);
        this.newKey = '';
        if (this.okey) {
          __WEBPACK_IMPORTED_MODULE_3_toastr__["success"]('Offline encrypted re-enabled');
        }
      }
    }
  })
});

/***/ }),

/***/ "WZhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ContentCopy_vue__ = __webpack_require__("lTNa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1eb54f6d_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ContentCopy_vue__ = __webpack_require__("RumR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ContentCopy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1eb54f6d_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ContentCopy_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1eb54f6d_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ContentCopy_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WcsN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon eye-off-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M11.83,9L15,12.16C15,12.11 15,12.05 15,12C15,10.34 13.66,9 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12C9,13.66 10.34,15 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17C9.24,17 7,14.76 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7C14.76,7 17,9.24 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "X6HY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CloudOffOutline_vue__ = __webpack_require__("oyKP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_91c45414_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CloudOffOutline_vue__ = __webpack_require__("bfye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CloudOffOutline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_91c45414_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CloudOffOutline_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_91c45414_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CloudOffOutline_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XBPP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row h-100 "},[_c('div',{staticClass:"login m-auto"},[(_vm.stepper)?_c('div',{staticClass:"card"},[_c('img',{staticClass:"login-logo",attrs:{"src":__webpack_require__("n9S4")}}),_vm._v(" "),_c('div',{staticClass:"card-body pb-0"},[_vm._m(0,false,false),_vm._v(" "),_c('p',[_vm._v("No settings or offline mode detected. Feel free to follow the\n          configuration wizard below. "),(!_vm.loggedIn)?_c('span',[_vm._v("Alternatively, you can switch to "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleStepper}},[_vm._v("Manual\n            mode")]),_vm._v(".")]):_vm._e()]),_vm._v(" "),_c('hr',{staticClass:"mb-0"})]),_vm._v(" "),_c('ul',{staticClass:"stepper stepper-vertical"},[_c('li',{class:{'active': _vm.step === 1, 'completed': _vm.step > 1}},[_c('a',{attrs:{"href":"#!"},on:{"click":function($event){_vm.setStep(1)}}},[_c('span',{staticClass:"circle"},[_vm._v("1")]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("SecretServer")])]),_vm._v(" "),(_vm.step == 1)?_c('div',{staticClass:"step-content"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.url),expression:"form.url"}],staticClass:"form-control",attrs:{"required":"","type":"text","id":"url","placeholder":"Enter Secret Server url","disabled":_vm.loggedIn},domProps:{"value":(_vm.form.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "url", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox float-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rememberUrl),expression:"rememberUrl"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"remember_url","disabled":_vm.loggedIn},domProps:{"checked":Array.isArray(_vm.rememberUrl)?_vm._i(_vm.rememberUrl,null)>-1:(_vm.rememberUrl)},on:{"change":function($event){var $$a=_vm.rememberUrl,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rememberUrl=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rememberUrl=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rememberUrl=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"remember_url"}},[_vm._v("remember")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-form-label col",attrs:{"for":"domain"}},[_vm._v("User Domain\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.domain),expression:"form.domain",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"domain","disabled":_vm.loggedIn},domProps:{"value":(_vm.form.domain)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "domain", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox float-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rememberDomain),expression:"rememberDomain"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"remember_domain","disabled":_vm.loggedIn},domProps:{"checked":Array.isArray(_vm.rememberDomain)?_vm._i(_vm.rememberDomain,null)>-1:(_vm.rememberDomain)},on:{"change":function($event){var $$a=_vm.rememberDomain,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rememberDomain=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rememberDomain=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rememberDomain=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"remember_domain"}},[_vm._v("remember")])])])]),_vm._v(" "),_c('p',[_vm._v("User Domain is optional, but required if your custom configuration requires it. If\n              available, it iss\n              normally found just below the normal login form.")]),_vm._v(" "),_c('button',{staticClass:"btn float-right purple darken-4 white-text px-5 z-depth-1",attrs:{"type":"button","disabled":(this.form.url === '')},on:{"click":function($event){_vm.setStep(2)}}},[_vm._v("\n              Next step\n            ")])]):_vm._e()]),_vm._v(" "),_c('li',{class:{'active': _vm.step === 2, 'completed': _vm.step > 2}},[_c('a',{attrs:{"href":"#!"},on:{"click":function($event){_vm.setStep(2)}}},[_c('span',{staticClass:"circle"},[_vm._v("2")]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("User Credentials")])]),_vm._v(" "),(_vm.step == 2)?_c('div',{staticClass:"step-content"},[(_vm.loggedIn)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n              You are logged in, continue with the next steps.\n            ")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("Please login to continue to your authenticators.")]),_vm._v(" "),_c('feedback'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-form-label col",attrs:{"for":"username"}},[_vm._v("Username*")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.username),expression:"form.username"}],staticClass:"form-control",attrs:{"required":"","type":"text","id":"username","disabled":_vm.loggedIn},domProps:{"value":(_vm.form.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "username", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox float-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rememberUser),expression:"rememberUser"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"remember_user","disabled":_vm.loggedIn},domProps:{"checked":Array.isArray(_vm.rememberUser)?_vm._i(_vm.rememberUser,null)>-1:(_vm.rememberUser)},on:{"change":function($event){var $$a=_vm.rememberUser,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rememberUser=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rememberUser=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rememberUser=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"remember_user"}},[_vm._v("remember")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-form-label col",attrs:{"for":"password"}},[_vm._v("Password*")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"form-control",attrs:{"required":"","type":"password","id":"password","disabled":_vm.loggedIn},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})])]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('p',[_vm._v("Authenticator code is required if your account uses an Authenticator or a One Time\n              Password. Leave it\n              blank otherwise.")]),_vm._v(" "),_c('div',{staticClass:"form-group row mb-4"},[_c('label',{staticClass:"col-form-label col",attrs:{"for":"password"}},[_vm._v("Authenticator code\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.OTP),expression:"form.OTP",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"password","id":"otp","disabled":_vm.loggedIn},domProps:{"value":(_vm.form.OTP)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.wizardLogin($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "OTP", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('button',{staticClass:"btn float-right purple darken-4 white-text px-5 z-depth-1",attrs:{"type":"button","disabled":(this.form.url === '' || this.form.user === '' || this.form.password === '')},on:{"click":_vm.wizardLogin}},[_vm._v("\n              Login\n            ")])],1):_vm._e()]),_vm._v(" "),_c('li',{class:{'active': _vm.step === 3, 'completed': _vm.step > 3}},[_c('a',{attrs:{"href":"#!"},on:{"click":function($event){_vm.setStep(3)}}},[_c('span',{staticClass:"circle"},[_vm._v("3")]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("4PA Settings")])]),_vm._v(" "),(_vm.step == 3)?_c('div',{staticClass:"step-content"},[_vm._m(3,false,false),_vm._v(" "),(_vm.preferences === false)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n              Fetching user preferences..\n            ")]):_vm._e(),_vm._v(" "),(_vm.preferences == 1)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n              No user preferences found, checking for company preferences..\n            ")]):_vm._e(),_vm._v(" "),(_vm.preferences == 3)?_c('div',[_c('div',{staticClass:"alert alert-success"},[_vm._v("\n                User preferences found and loaded, no configuration remaining.\n              ")]),_vm._v(" "),(_vm.okey)?_c('router-link',{staticClass:"btn float-right purple darken-4 white-text py-2 px-4 z-depth-1",attrs:{"replace":"","to":{name: 'authenticators'}}},[_vm._v("\n                To authenticators\n              ")]):_vm._e(),_vm._v(" "),(!_vm.okey)?_c('button',{staticClass:"btn float-right purple darken-4 white-text px-5 z-depth-1",attrs:{"type":"button"},on:{"click":function($event){_vm.setStep(4)}}},[_vm._v("\n                Next step\n              ")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.preferences == 4)?_c('div',[_c('div',{staticClass:"alert alert-success"},[_vm._v("\n                Company references found and loaded, almost done.\n              ")]),_vm._v(" "),_c('button',{staticClass:"btn float-right purple darken-4 white-text px-5 z-depth-1",attrs:{"type":"button"},on:{"click":function($event){_vm.setStep(4)}}},[_vm._v("\n                Next step\n              ")])]):_vm._e(),_vm._v(" "),(_vm.preferences === 2 || _vm.preferences === 0)?_c('div',{staticClass:"settings-form"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n                No preferences found, manual configuration required.\n              ")]),_vm._v(" "),_c('p',[_vm._v("Need help\n                "),_c('a',{staticClass:"d-inline p-0",attrs:{"href":"#"},on:{"click":_vm.showHelp}},[_vm._v("how to configure secret\n                  server")]),_vm._v("\n                ?\n              ")]),_vm._v(" "),_c('div',{staticClass:"form-group pb-2"},[_c('label',{attrs:{"for":"template_id"}},[_vm._v("Authenticator template id")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newTemplateId),expression:"newTemplateId"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1","id":"template_id","disabled":_vm.preferences == 3},domProps:{"value":(_vm.newTemplateId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newTemplateId=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn float-right purple darken-4 white-text px-5 z-depth-1",attrs:{"type":"button"},on:{"click":_vm.storeTemplateId}},[_vm._v("\n                Next step\n              ")])]):_vm._e()]):_vm._e()]),_vm._v(" "),(!_vm.okey)?_c('li',{class:{'active': _vm.step === 4, 'completed': _vm.step > 4}},[_c('a',{attrs:{"href":"#!"},on:{"click":function($event){_vm.setStep(4)}}},[_c('span',{staticClass:"circle"},[_vm._v("4")]),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Offline mode")])]),_vm._v(" "),(_vm.step == 4)?_c('div',{staticClass:"step-content"},[_c('p',[_vm._v("4PA Authenticator's can be used without an active internet connection. This is optional\n              and requires\n              you to create an offline passphrase. This passphrase is used to encrypt your data\n              locally.")]),_vm._v(" "),_c('div',{staticClass:"okey-form"},[_c('p',[_vm._v("\n                If disabled, your session is limited to 20 minutes and you will be logged out after\n                expiration.")]),_vm._v(" "),_c('div',{staticClass:"form-group pb-2"},[_c('label',{attrs:{"for":"offline_key"}},[_vm._v("Offline passphrase")]),_vm._v(" "),_c('div',{staticClass:"input-group z-depth-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newKey),expression:"newKey"}],staticClass:"form-control",attrs:{"type":"password","id":"offline_key"},domProps:{"value":(_vm.newKey)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.storeNewEncryptKey($event)},"input":function($event){if($event.target.composing){ return; }_vm.newKey=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn purple darken-4 white-text",attrs:{"type":"button","id":"button-addon2"},on:{"click":_vm.storeNewEncryptKey}},[_vm._v("\n                      Enable offline mode\n                    ")])])])]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("\n                Please note, whilst in offline mode it is not possible to retrieve new data without\n                going online\n                first.")])]),_vm._v(" "),_c('router-link',{staticClass:"btn float-right btn-outline-dark p-2 px-4",attrs:{"to":{name: 'authenticators'},"replace":""}},[_vm._v("\n              Continue as online-only session\n            ")])],1):_vm._e()]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.stepper)?_c('div',{staticClass:"card"},[_c('img',{staticClass:"login-logo",attrs:{"src":__webpack_require__("n9S4")}}),_vm._v(" "),(!_vm.showOtp && !_vm.showOffline)?_c('form',{staticClass:"card-body"},[_c('p',{staticClass:"text-center"},[_vm._v("Login to continue to your "),_c('strong',[_vm._v("4Passwords Authenticators")]),_vm._v("."),_c('br'),_vm._v("\n          Use the "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleStepper}},[_vm._v("configuration\n            wizard")]),_vm._v(".")]),_vm._v(" "),_c('hr',{staticClass:"mx-4 mt-0"}),_vm._v(" "),_c('feedback',{staticClass:"mb-4"}),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.url),expression:"form.url"}],staticClass:"form-control",attrs:{"required":"","type":"text","id":"url","placeholder":"Enter Secret Server url"},domProps:{"value":(_vm.form.url)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "url", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox float-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rememberUrl),expression:"rememberUrl"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"remember_url"},domProps:{"checked":Array.isArray(_vm.rememberUrl)?_vm._i(_vm.rememberUrl,null)>-1:(_vm.rememberUrl)},on:{"change":function($event){var $$a=_vm.rememberUrl,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rememberUrl=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rememberUrl=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rememberUrl=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"remember_url"}},[_vm._v("remember")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-form-label col",attrs:{"for":"username"}},[_vm._v("Username*")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.username),expression:"form.username"}],staticClass:"form-control",attrs:{"required":"","type":"text","id":"username"},domProps:{"value":(_vm.form.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "username", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox float-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rememberUser),expression:"rememberUser"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"remember_user"},domProps:{"checked":Array.isArray(_vm.rememberUser)?_vm._i(_vm.rememberUser,null)>-1:(_vm.rememberUser)},on:{"change":function($event){var $$a=_vm.rememberUser,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rememberUser=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rememberUser=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rememberUser=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"remember_user"}},[_vm._v("remember")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-form-label col",attrs:{"for":"password"}},[_vm._v("Password*")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"form-control",attrs:{"required":"","type":"password","id":"password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})])]),_vm._v(" "),_c('hr',{staticClass:"my-4"}),_vm._v(" "),_c('div',{staticClass:"form-group row mb-4"},[_c('label',{staticClass:"col-form-label col",attrs:{"for":"password"}},[_vm._v("Authenticator code\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.OTP),expression:"form.OTP",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"password","id":"otp"},domProps:{"value":(_vm.form.OTP)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "OTP", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-form-label col",attrs:{"for":"domain"}},[_vm._v("User Domain\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.domain),expression:"form.domain",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","id":"domain"},domProps:{"value":(_vm.form.domain)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "domain", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"custom-control custom-checkbox float-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rememberDomain),expression:"rememberDomain"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"remember_domain"},domProps:{"checked":Array.isArray(_vm.rememberDomain)?_vm._i(_vm.rememberDomain,null)>-1:(_vm.rememberDomain)},on:{"change":function($event){var $$a=_vm.rememberDomain,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.rememberDomain=$$a.concat([$$v]))}else{$$i>-1&&(_vm.rememberDomain=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.rememberDomain=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"remember_domain"}},[_vm._v("remember")])])])]),_vm._v(" "),_c('div',{staticClass:"text-center mt-4"},[_c('button',{staticClass:"btn float-right purple darken-4 white-text px-5 z-depth-1",attrs:{"disabled":_vm.isLoading,"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.post(_vm.form)}}},[_vm._v("Login\n          ")])])],1):_vm._e(),_vm._v(" "),(_vm.showOtp)?_c('form',{staticClass:"card-body"},[_c('h3',{staticClass:"dark-grey-text card-title"},[_vm._v("OTP")]),_vm._v(" "),_c('p',[_vm._v("This account has an Authenticator enabled, please enter it to confirm the log in.")]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{attrs:{"for":"password"}},[_vm._v("OTP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.form.OTP),expression:"form.OTP",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"password","id":"otp","placeholder":"Enter password"},domProps:{"value":(_vm.form.OTP)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "OTP", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"disabled":_vm.isLoading,"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.post(_vm.form)}}},[_vm._v("Login\n          ")])])]):_vm._e(),_vm._v(" "),(_vm.showOffline)?_c('form',{staticClass:"card-body"},[_vm._m(5,false,false),_vm._v(" "),_c('button',{staticClass:"btn btn-outline-secondary ml-2 float-right",attrs:{"type":"button"},on:{"click":_vm.deleteOfflineStore}},[_vm._v("× Clear Offline Data\n        ")]),_vm._v(" "),_c('h3',{staticClass:"dark-grey-text card-title mb-4"},[_vm._v("Offline-mode")]),_vm._v(" "),_vm._m(6,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex flex-column"},[_c('feedback'),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col col-form-label",attrs:{"for":"offline_key"}},[_vm._v("Offline passphrase")]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.offlineKey),expression:"offlineKey"}],staticClass:"form-control",attrs:{"type":"password","id":"offline_key","placeholder":"Enter offline passphrase"},domProps:{"value":(_vm.offlineKey)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.parseOkey($event)},"input":function($event){if($event.target.composing){ return; }_vm.offlineKey=$event.target.value}}})])]),_vm._v(" "),_c('button',{staticClass:"ml-auto btn purple darken-4 white-text px-5 z-depth-1",attrs:{"disabled":_vm.isLoading,"type":"submit"},on:{"click":function($event){$event.preventDefault();_vm.parseOkey($event)}}},[_vm._v("\n            Unlock\n          ")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.showLogin($event)}}},[_vm._v("Login")]),_vm._v("\n          for online mode.")])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p-4 d-flex justify-content-between"},[_c('a',{staticClass:"btn-link purple-text darken",attrs:{"href":"#"},on:{"click":_vm.showPrivacy}},[_vm._v("\n        Privacy Policy\n      ")]),_vm._v(" "),_c('a',{staticClass:"btn-link purple-text darken",attrs:{"href":"#"},on:{"click":_vm.showDisclaimer}},[_vm._v("\n        Disclaimer\n      ")]),_vm._v(" "),_c('a',{staticClass:"btn-link purple-text darken",attrs:{"href":"#"},on:{"click":_vm.showHelp}},[_vm._v("\n        Help\n      ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center mb-2"},[_c('small',[_vm._v("v"+_vm._s(_vm.version))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Welcome to the "),_c('strong',[_vm._v("4Password Authenticators")]),_vm._v(" first-time setup wizard!")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("From which secure URL can we reach your "),_c('strong',[_vm._v("Secret Server")]),_vm._v("? Toggling remember\n              will store\n              your those credentials for the next time you use 4PA Authenticators.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label col",attrs:{"for":"url"}},[_vm._v("Secret Server URL"),_c('sup',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You're now logged in. "),_c('br'),_vm._v("\n              Almost done, 4PA needs to configure which template can be retrieved for authenticators.\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"col-form-label col",attrs:{"for":"url"}},[_vm._v("Secret Server URL"),_c('sup',[_vm._v("*")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center"},[_c('strong',[_vm._v("4Passwords authenticators ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Offline encrypted storage")]),_vm._v(" detected, enter your passphrase to continue.\n        ")])}]


/***/ }),

/***/ "XfbO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon close-circle-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "YMHA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon reload-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M19,12H22.32L17.37,16.95L12.42,12H16.97C17,10.46 16.42,8.93 15.24,7.75C12.9,5.41 9.1,5.41 6.76,7.75C4.42,10.09 4.42,13.9 6.76,16.24C8.6,18.08 11.36,18.47 13.58,17.41L15.05,18.88C12,20.69 8,20.29 5.34,17.65C2.22,14.53 2.23,9.47 5.35,6.35C8.5,3.22 13.53,3.21 16.66,6.34C18.22,7.9 19,9.95 19,12Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "YPh/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authenticators_vue__ = __webpack_require__("AnFO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0d3103a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authenticators_vue__ = __webpack_require__("pLdQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authenticators_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0d3103a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authenticators_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0d3103a_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authenticators_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YRA+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("lhHW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_07e7500d_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("QHWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_07e7500d_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_07e7500d_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Settings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Login__ = __webpack_require__("3jL2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Authenticators__ = __webpack_require__("YPh/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Privacy__ = __webpack_require__("MV//");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Disclaimer__ = __webpack_require__("ehzB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Help__ = __webpack_require__("ZCnB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_SettingsList__ = __webpack_require__("6NTW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_settings_AuthenticatorSettings__ = __webpack_require__("Faif");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_settings_OfflineSettings__ = __webpack_require__("rXQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__guards_AppInit__ = __webpack_require__("AQ8/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__guards_IsLoggedIn__ = __webpack_require__("W3tM");





// import Settings from '../components/pages/Settings';









// import RedirectIfLoggedIn from './guards/RedirectIfLoggedIn';


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'authenticators',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Authenticators__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_11__guards_IsLoggedIn__["a" /* default */]
  }, {
    path: '/settings',
    name: 'settings',
    component: __WEBPACK_IMPORTED_MODULE_7__components_pages_SettingsList__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_11__guards_IsLoggedIn__["a" /* default */]
  }, {
    path: '/settings/authenticators',
    name: 'settings.authenticator',
    component: __WEBPACK_IMPORTED_MODULE_8__components_pages_settings_AuthenticatorSettings__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_11__guards_IsLoggedIn__["a" /* default */]
  }, {
    path: '/settings/encrypted-offline-mode',
    name: 'settings.offline',
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_settings_OfflineSettings__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_11__guards_IsLoggedIn__["a" /* default */]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Login__["a" /* default */]
    // beforeEnter: RedirectIfLoggedIn
  }, {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_Privacy__["a" /* default */]
  }, {
    path: '/disclaimer',
    name: 'disclaimer',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Disclaimer__["a" /* default */]
  }, {
    path: '/help',
    name: 'help',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_Help__["a" /* default */]
  }]
});

router.beforeEach(__WEBPACK_IMPORTED_MODULE_10__guards_AppInit__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YqEc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"content-popup container-fluid d-block scrollbar py-2",class:{'white card' : !_vm.loggedin}},[_c('div',{staticClass:"container"},[_c('button',{staticClass:"btn btn-outline-secondary my-2 float-right",on:{"click":_vm.hide}},[_vm._v("× Close")]),_vm._v(" "),_c('h1',[_vm._v("Privacy Policy")]),_vm._v(" "),_c('small',[_vm._v("Last update: June 17, 2019")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("INTRODUCTION")]),_vm._v(" "),_c('p',[_vm._v("\n      Welcome to the 4Passwords Authenticator, a free, client-side app for interacting with One Time passwords shared\n      from a Thycotic Secret Server.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      4Passwords values privacy and we make a concerted effort to minimize and, to the extent possible, eliminate the\n      exposure of personal data during the use of our app. We do not collect, hold, or store keys, account\n      information,\n      or passwords online on our website or servers. We do not collect data passively, do not monetize the collection\n      of\n      data, and do not use your data for marketing or advertising.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      To the extent when we collect any personal information, this privacy policy (“Policy”) describes how 4Passwords\n      collects, uses, and shares personal information of people who visit our website (the “Site”), use our compiled\n      applications (on Windows, IOS, Android, OSX & Linux), or otherwise use our services (collectively, the\n      “Services”).\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      This Policy applies to anyone who accesses the Services. Please read the Policy carefully to understand our\n      practices regarding your information and how we will treat it. By visiting the Site and/or using the App or our\n      Services, you acknowledge that the collection, use, and sharing of your information will take place as described\n      in this Policy.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      So that we are clear about the terminology we are using, when we use the phrase “Personal Information” in this\n      Privacy Policy, we mean information about an individual that (either by itself or when combined with information\n      from other available sources) allows that individual to be identified, including, the individual’s name,\n      telephone number, or e-mail address. ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("\n      THE 4PASSWORDS AUTHENTICATOR\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      The goal of the 4Passwords Authenticator app is to efficiently and securely use online or cached offline One\n      Time Passwords (OTP’s) that are shared and stored within a Thycotic On-premise of cloud based Secret Server.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      One Time Passwords (OTP’s) are also known as Google , Microsoft, TOTP Authenticators, and as MFA (Multi-factor),\n      2FA (Two factor Authentication) Keys.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      The 4Passwords Authenticator is a client-side app that runs exclusively in a client’s browser and computer. Once\n      the application is downloaded from either 4Passwords.com, 4pa.app or your own hosted servers, then the app will\n      receive and send data through the app with the configured Thycotic Secret Server and its enabled web services\n      API. The app will never send any data to any other system or website then the configured Secret Server within\n      the app.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      The One Time Passwords that you see inside the app are secrets that are shared with you from within a Thycotic\n      Secret Server. Modifying, adding and / or sharing One Time Passwords in the free version needs to be done from\n      the Thycotic Secret Server interface with a pre-configured Authenticator template.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      The optional offline cache will be protected by a passphrase that encrypts your OTP keys inside the app or\n      browser cache with 256-bit AES encryption.\n    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("\n      WHAT WE COLLECT\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We collect information about you as described below. We use this information to enhance your experience with our\n      Services.\n    ")]),_vm._v(" "),_c('h3',[_vm._v("\n      Information You Provide\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We may collect Personal Information you choose to provide to us. For example, when you contact us for support\n      through the Services, you give us your e-mail address and any other information that you choose to provide.\n      Also, if you participate in a 4Passwords Authenticator offer, give-away, or promotion (“Promotion”), you provide\n      your name, e-mail address, and mailing address.\n    ")]),_vm._v(" "),_c('h3',[_vm._v("\n      California Do Not Track Disclosures\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      4Passwords Authenticator does not track users over time and across third party websites to provide targeted\n      advertising and therefore does not respond to Do Not Track (DNT) signals.\n    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("\n      USE OF INFORMATION\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We use the information that we have about you to provide support and certain Services to you.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We may use the Personal Information we collect from and about you to (1) provide you with information or\n      services that you request from us, including to respond to your comments, questions, and/or provide customer\n      service; (2) monitor and analyze usage and trends and personalize and improve the Services and your experience\n      using the Services; and (3) for any other purpose with your consent.\n    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("\n      SHARING OF PERSONAL INFORMATION\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We will not disclose your Personal Information other than as described below, and we do not and will not sell\n      your Personal Information to anyone.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We may share the Personal Information we collect from and about you (1) to fulfill the purpose for which you\n      provided it; (2) with your consent; (3) for legal, protection, and safety purposes; (4) to comply with any court\n      order, law, or legal process, including to respond to any government or regulatory request; (5) to protect the\n      rights of the 4Passwords Authenticator, our agents, customers, and others, including by enforcing our\n      agreements, policies, and terms of service; and (6) with those who need it to do work for us (our Service\n      Providers, as defined below).\n    ")]),_vm._v(" "),_c('h3',[_vm._v("\n      Service providers\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We may contract with third parties to perform functions related to the Services (“Service Providers”). In\n      general, Service Providers will have access to your Personal Information only to the extent needed to perform\n      their business functions but may not use or share that personal information for purposes outside the scope of\n      their functions related to the Services.\n    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("\n      LINKS TO OTHER SITES\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      The Services contain links to other third-party websites or applications. Once you click on such a link and\n      leave the Site or are redirected to a third-party website or application, you are no longer governed by this\n      Policy. Any information you provide on those sites is subject to that third party’s privacy policy and we are\n      not responsible for the privacy and security practices and policies of those third-party sites or applications.\n    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("\n      SECURITY OF YOUR PERSONAL INFORMATION & RIGHTS\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We are committed to protecting the security of Personal Information. We have taken certain physical,\n      administrative, and technical steps to help safeguard the information we collect from and about you. While we\n      take steps to help ensure the integrity and security of our network and systems, we cannot guarantee our\n      security measures.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      In certain circumstances, you will also have the following rights:\n    ")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('h3',[_vm._v("\n      Legal Basis for Processing\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      The following legal bases apply to the ways in which we use and share an individual’s Personal Information:\n    ")]),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("\n      RETENTION\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We will retain the information you provide in order to process your request, provide support, and/or carry out\n      and fulfill our Promotions. If you request support, we will retain your information for no longer than six (12)\n      months. If you participate in a Promotion, we will retain your information until the Promotion is carried out\n      and ninety (90) days after any prize, reward, or offer is fulfilled. Your Personal Information will then be\n      deleted.\n    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("\n      CONTACT INFORMATION\n    ")]),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("\n      CHANGES TO PRIVACY POLICY\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We may modify this Policy from time to time. If we make any changes, we will change the Last Updated date above.\n      We also may provide additional notice, as applicable, depending on the type of change. If you object to any\n      changes, you may stop using the Services. Your continued use of the Services after we publish or otherwise\n      provide notice about our changes to the Policy means that you are consenting to the updated Policy.\n    ")])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("\n        Right to access: the right to request certain information about, access to and copies of any Personal\n        Information about you that we are holding (please note that you are entitled to request one copy of the\n        Personal Information that we hold about you at no cost, but for any further copies, we reserve the right to\n        charge a reasonable fee based on administration costs);\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        Right to rectification: the right to have your Personal Information rectified if it is inaccurate or\n        incomplete;\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        Right to erasure/“right to be forgotten”: where the processing of your information is based on your consent,\n        the right to withdraw that consent and the right to request that we delete or erase your Personal Information\n        from our systems (however, this will not apply if we are required to hold on to the information for compliance\n        with any legal obligation, or if we require the information to establish or defend any legal claim);\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        Right to restriction of use of your information: the right to stop us from using your Personal Information or\n        limit the way in which we can use it;\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        Right to data portability: the right to request that we return any information you have provided in a\n        structured, commonly used, and machine-readable format, or that we send it directly to another company, where\n        technically feasible.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        Right to object: the right to object to our use of your Personal Information including where we use it for our\n        legitimate interests.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      Requests in relation to the above rights should be sent to: "),_c('a',{attrs:{"href":"mailto:privacy@4passwords.com","target":"_blank"}},[_vm._v("privacy@4passwords.com")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("\n        We rely on an individual’s consent to process Personal Information to provide support and/or carry out\n        Promotions. This consent can be withdrawn at any time.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        We also process the information provided by an individual in our legitimate interests in ensuring our business\n        is conducted legitimately and to a high standard.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n      We welcome your comments or questions about this Policy. You may contact us at "),_c('a',{attrs:{"href":"mailto:privacy@4passwords.com","target":"_blank"}},[_vm._v("privacy@4passwords.com")])])}]


/***/ }),

/***/ "YsJY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LockClockIcon",
  props: {
    title: {
      type: String,
      default: "Lock Clock icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "YxxN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LockIcon",
  props: {
    title: {
      type: String,
      default: "Lock icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "ZCnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__ = __webpack_require__("iAh9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b81611e2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__ = __webpack_require__("knv1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b81611e2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b81611e2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZWa9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZZwB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


// import Vue from 'vue';



var qs = __webpack_require__("mw3O");

/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(data) {
    var newData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, data.form);
    data.form.password = '';
    newData.grant_type = "password";
    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(newData.url + '/oauth2/token', qs.stringify(newData)).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  authenticate: function authenticate() {
    var url = __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url + '/api/v1/users/current').then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  }
});

/***/ }),

/***/ "aMAe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CheckboxMarkedOutlineIcon",
  props: {
    title: {
      type: String,
      default: "Checkbox Marked Outline icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "b4RV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ArrowLeftIcon",
  props: {
    title: {
      type: String,
      default: "Arrow Left icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "bNYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

// import Vue from 'vue';




/* harmony default export */ __webpack_exports__["a"] = ({
  getSecrets: function getSecrets() {
    var url = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url + '/api/v1/secrets').then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  getSecret: function getSecret(id) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url + ('/api/v1/secrets/' + id)).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  getSecretTemplates: function getSecretTemplates() {
    var url = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url + '/api/v1/secret-templates').then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  getSecretTemplate: function getSecretTemplate(id) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url + ('/api/v1/secret-templates/' + id)).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  searchSecrets: function searchSecrets(params) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url + '/api/v1/secrets', params).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  },
  postSecret: function postSecret(payload) {
    var url = __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* default */].getters['auth/url'];
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url + '/api/v1/secrets', payload).then(function (response) {
      return response.data;
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response);
    });
  }
});

/***/ }),

/***/ "bfye":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon cloud-off-outline-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M7.73,10L15.73,18H6C3.79,18 2,16.21 2,14C2,11.79 3.79,10 6,10M3,5.27L5.75,8C2.56,8.15 0,10.77 0,14C0,17.31 2.69,20 6,20H17.73L19.73,22L21,20.73L4.27,4M19.35,10.03C18.67,6.59 15.64,4 12,4C10.5,4 9.15,4.43 8,5.17L9.45,6.63C10.21,6.23 11.08,6 12,6C15.04,6 17.5,8.46 17.5,11.5V12H19C20.66,12 22,13.34 22,15C22,16.13 21.36,17.11 20.44,17.62L21.89,19.07C23.16,18.16 24,16.68 24,15C24,12.36 21.95,10.22 19.35,10.03Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "cJ9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CloudOutline_vue__ = __webpack_require__("keaL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_73c1746d_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CloudOutline_vue__ = __webpack_require__("lczC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CloudOutline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_73c1746d_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CloudOutline_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_73c1746d_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CloudOutline_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cL2p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UploadIcon",
  props: {
    title: {
      type: String,
      default: "Upload icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "cbTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings scrollbar"},[_c('div',{staticClass:"settings-header"},[_c('button',{staticClass:"history-back",attrs:{"type":"button"},on:{"click":_vm.previous}},[_c('arrow-left-icon')],1),_vm._v("\n    Settings\n\n  ")]),_vm._v(" "),_c('hr',{staticClass:"settings-divider"}),_vm._v(" "),(!_vm.offlineMode)?_c('div',[_c('p',{staticClass:"settings-head"},[_vm._v("\n      User settings\n    ")]),_vm._v(" "),_c('button',{staticClass:"block",attrs:{"type":"button","disabled":_vm.fetching},on:{"click":_vm.postPersonalPreferences}},[_c('upload-icon'),_vm._v(" "),_vm._m(0,false,false)],1),_vm._v(" "),_c('button',{staticClass:"block",attrs:{"type":"button","disabled":_vm.fetching},on:{"click":_vm.getPersonalPreferences}},[_c('download-icon'),_vm._v(" "),_vm._m(1,false,false)],1),_vm._v(" "),_c('a',{staticClass:"block",attrs:{"href":_vm.settingsUrl,"target":"_blank"}},[_c('open-in-new-icon'),_vm._v(" "),_c('span',{staticClass:"settings-text"},[_vm._v("\n      Edit settings on server\n    ")])],1),_vm._v(" "),_c('hr',{staticClass:"settings-divider"})]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"settings-head"},[_vm._v("\n    Configuration\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"block",attrs:{"to":{name: 'settings.authenticator'}}},[_c('settings-icon'),_vm._v(" "),_c('span',{staticClass:"settings-text"},[_vm._v("\n     Authenticator settings\n    ")])],1),_vm._v(" "),_c('router-link',{staticClass:"block",attrs:{"to":{name: 'settings.offline'}}},[_c('security-icon'),_vm._v(" "),_c('span',{staticClass:"settings-text"},[_vm._v("\n     Encrypted Offline mode\n    ")])],1),_vm._v(" "),_c('hr',{staticClass:"settings-divider"}),_vm._v(" "),_c('p',{staticClass:"settings-head"},[_vm._v("\n    Looking for more?\n  ")]),_vm._v(" "),_c('button',{staticClass:"block",attrs:{"type":"button"},on:{"click":_vm.showPrivacy}},[_c('view-list-icon'),_vm._v(" "),_c('span',{staticClass:"settings-text"},[_vm._v("\n      Privacy Policy\n    ")])],1),_vm._v(" "),_c('button',{staticClass:"block",attrs:{"type":"button"},on:{"click":_vm.showDisclaimer}},[_c('alert-icon'),_vm._v(" "),_c('span',{staticClass:"settings-text"},[_vm._v("\n      Disclaimer\n    ")])],1),_vm._v(" "),_c('button',{staticClass:"block",attrs:{"type":"button"},on:{"click":_vm.showHelp}},[_c('help-circle-icon'),_vm._v(" "),_c('span',{staticClass:"settings-text"},[_vm._v("\n      Help\n    ")])],1),_vm._v(" "),_c('small',{staticClass:"version"},[_vm._v("v"+_vm._s(_vm.version))])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"settings-text"},[_vm._v("\n      Save to server"),_c('br'),_vm._v(" "),_c('small',[_vm._v("Favorites, Settings and offline-passphrase")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"settings-text"},[_vm._v("\n      Import from server"),_c('br'),_vm._v(" "),_c('small',[_vm._v("Favorites, Settings and offline-passphrase")])])}]


/***/ }),

/***/ "dTkO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon security-close-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M17,15.59L15.59,17L12,13.41L8.41,17L7,15.59L10.59,12L7,8.41L8.41,7L12,10.59L15.59,7L17,8.41L13.41,12L17,15.59Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "drpm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon arrow-left-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "e9KC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_design_icons_Eye__ = __webpack_require__("toqK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_design_icons_EyeOff__ = __webpack_require__("CfOl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_ContentCopy__ = __webpack_require__("WZhI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_Loading__ = __webpack_require__("4pyI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_CloseCircle__ = __webpack_require__("4ur8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_toastr__ = __webpack_require__("vQJi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__node_modules_vue_material_design_icons_OpenInNew_vue__ = __webpack_require__("JtXI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_vue_material_design_icons_StarOutline_vue__ = __webpack_require__("rFQp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__node_modules_vue_material_design_icons_Star_vue__ = __webpack_require__("K1kK");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














__WEBPACK_IMPORTED_MODULE_7_toastr__["options"].timeout = 1500;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'authenticator',
  props: {
    secretId: {
      type: Number,
      default: null
    },
    time: {
      type: Number,
      default: null
    }
  },
  watch: {
    time: {
      handler: function handler(val) {
        // eslint-disable-line
        if (val === 30 || !this.dispatched) {
          this.generateOtps();
        }
      },
      immediate: true
    }
  },
  components: {
    StarIcon: __WEBPACK_IMPORTED_MODULE_10__node_modules_vue_material_design_icons_Star_vue__["a" /* default */],
    StarOutlineIcon: __WEBPACK_IMPORTED_MODULE_9__node_modules_vue_material_design_icons_StarOutline_vue__["a" /* default */],
    OpenInNewIcon: __WEBPACK_IMPORTED_MODULE_8__node_modules_vue_material_design_icons_OpenInNew_vue__["a" /* default */],
    EyeIcon: __WEBPACK_IMPORTED_MODULE_2_vue_material_design_icons_Eye__["a" /* default */],
    EyeOffIcon: __WEBPACK_IMPORTED_MODULE_3_vue_material_design_icons_EyeOff__["a" /* default */],
    ContentCopyIcon: __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_ContentCopy__["a" /* default */],
    LoadingIcon: __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_Loading__["a" /* default */],
    CloseCircleIcon: __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_CloseCircle__["a" /* default */]
  },
  data: function data() {
    return {
      dispatched: false,
      otp: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    url: 'auth/url',
    offlineMode: 'auth/offlineMode',
    secrets: 'authenticators/all',
    getById: 'authenticators/getById',
    favorites: 'authenticators/favorites',
    templateId: 'authenticators/templateId',
    okey: 'settings/okey',
    alwaysShowOtp: 'settings/showOtp',
    personalFolderId: 'authenticators/personalFolderId'
  }), {
    favoriteFeature: function favoriteFeature() {
      return this.okey || this.favorites.length >= 1 || !this.offlineMode;
      // return (!this.offlineMode && this.okey && this.personalFolderId) || this.favorites.length >= 1;
    },
    canFavorite: function canFavorite() {
      return this.okey || !this.offlineMode;
      // return (!this.offlineMode && this.okey && this.personalFolderId) || this.favorites.length >= 1;
    },
    secret: function secret() {
      return this.getById(this.secretId);
    },
    showOtp: function showOtp() {
      return this.otp || this.alwaysShowOtp;
    },
    favorited: function favorited() {
      return this.favorites.includes(this.secret.id);
    },
    mask: function mask() {
      if (this.secret.otp) {
        if (this.showOtp) {
          return this.secret.otp;
        }
        return '******';
      }
      return this.secret.otp;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    generateOtp: 'authenticators/generateOtp',
    setLoading: 'loading/setLoading',
    setDelayedFeedback: 'feedback/setDelayedFeedback',
    toggleFavorite: 'authenticators/toggleFavorite'
  }), {
    toggleShowOtp: function toggleShowOtp() {
      this.otp = !this.otp;
    },
    secretUrl: function secretUrl(id) {
      return this.url + '/SecretView.aspx?secretid=' + id;
    },
    generateOtps: function generateOtps() {
      if (this.secretId) {
        this.dispatched = true;
        this.$store.dispatch('authenticators/generateOtp', this.secretId);
      }
    },
    fieldType: function fieldType() {
      return 'text';
      // if (this.showOtp || this.alwaysShowOtp) {
      //   return 'text';
      // }
      // return 'password';
    },
    copy: function copy(id) {
      if (this.secrets[id].otp === 'undefined') {
        __WEBPACK_IMPORTED_MODULE_7_toastr__["error"]('Unable to copy.');
        return false;
      }
      return this.clip(this.secrets[id].otp);
    },
    clip: function clip(str) {
      var el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      var selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
        __WEBPACK_IMPORTED_MODULE_7_toastr__["success"]('One Time Password copied');
      }
    },
    favorite: function favorite() {
      if (this.canFavorite) {
        this.toggleFavorite(this.secret.id);
      }
    }
  })
});

/***/ }),

/***/ "e9OB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings scrollbar settings-authenticator"},[_c('div',{staticClass:"settings-header"},[_c('button',{staticClass:"history-back",attrs:{"type":"button"},on:{"click":_vm.previous}},[_c('arrow-left-icon')],1),_vm._v("\n    Authenticator settings\n\n  ")]),_vm._v(" "),(!_vm.offlineMode&&_vm.templateId)?_c('div',[_c('hr',{staticClass:"settings-divider"}),_vm._v(" "),_c('button',{staticClass:"block",attrs:{"type":"button","disabled":_vm.fetching},on:{"~click":function($event){_vm.refreshAuthenticators($event)}}},[_c('reload-icon'),_vm._v(" "),_c('span',{staticClass:"settings-text"},[_vm._v("\n      Reload authenticators\n    ")])],1)]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"settings-divider"}),_vm._v(" "),_c('div',{staticClass:"settings-body"},[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.post(_vm.form)}}},[_c('div',{staticClass:"form-group pb-2"},[_c('div',{staticClass:"custom-control custom-checkbox float-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.advancedTemplate),expression:"form.advancedTemplate"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"advanced_template","disabled":_vm.offlineMode},domProps:{"checked":Array.isArray(_vm.form.advancedTemplate)?_vm._i(_vm.form.advancedTemplate,null)>-1:(_vm.form.advancedTemplate)},on:{"change":[function($event){var $$a=_vm.form.advancedTemplate,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.form.advancedTemplate=$$a.concat([$$v]))}else{$$i>-1&&(_vm.form.advancedTemplate=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.form, "advancedTemplate", $$c)}},function($event){_vm.post(_vm.form)}]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"advanced_template"}},[_vm._v("Manual input")])]),_vm._v(" "),_c('label',{attrs:{"for":"template_id"}},[_vm._v("Authenticator template")]),_vm._v(" "),(!_vm.form.advancedTemplate)?_c('Select2',{attrs:{"id":"template_id","options":_vm.possibleAuthenticatorTemplates,"disabled":_vm.offlineMode,"settings":{}},on:{"change":function($event){_vm.post(_vm.form)}},model:{value:(_vm.form.templateId),callback:function ($$v) {_vm.$set(_vm.form, "templateId", $$v)},expression:"form.templateId"}}):_vm._e(),_vm._v(" "),(_vm.form.advancedTemplate)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.templateId),expression:"form.templateId"}],staticClass:"form-control",attrs:{"type":"number","min":"0","step":"1","id":"template_id","disabled":_vm.offlineMode},domProps:{"value":(_vm.form.templateId)},on:{"change":function($event){_vm.post(_vm.form)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "templateId", $event.target.value)}}}):_vm._e(),_vm._v(" "),_c('small',[_vm._v(" Need help\n          "),_c('a',{staticClass:"d-inline p-0",attrs:{"href":"#"},on:{"click":_vm.showHelp}},[_vm._v("how to configure secret\n            server")]),_vm._v("\n          ?\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"form-group pb-2"},[_c('div',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.show),expression:"form.show"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"show_otp"},domProps:{"checked":Array.isArray(_vm.form.show)?_vm._i(_vm.form.show,null)>-1:(_vm.form.show)},on:{"change":[function($event){var $$a=_vm.form.show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.form.show=$$a.concat([$$v]))}else{$$i>-1&&(_vm.form.show=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.form, "show", $$c)}},function($event){_vm.post(_vm.form)}]}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":"show_otp"}},[_vm._v("Always show One Time Passwords")])])]),_vm._v(" "),(!_vm.showAdvanced&&!_vm.form.advancedTemplate)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleShowAdvanced}},[_vm._v("Show advanced template\n        configuration")]):_vm._e(),_vm._v(" "),(_vm.showAdvanced&&!_vm.form.advancedTemplate)?_c('a',{attrs:{"href":"#"},on:{"click":_vm.toggleShowAdvanced}},[_vm._v("Hide advanced template configuration")]):_vm._e(),_vm._v(" "),(_vm.showAdvanced&&!_vm.form.advancedTemplate)?_c('div',{staticClass:"card-body border"},[_c('a',{staticClass:"btn btn-sm btn-link float-right ml-2",attrs:{"href":"#"},on:{"click":_vm.resetTemplateFilter}},[_vm._v("Reset\n          to default")]),_vm._v(" "),_c('p',[_vm._v("Terms used to match possible authenticator secret templates:")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.newTemplateFilter),expression:"form.newTemplateFilter"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.newTemplateFilter)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.postTemplateFilter($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "newTemplateFilter", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":_vm.postTemplateFilter}},[_vm._v("\n              Add term\n            ")])])]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush mb-5"},_vm._l((_vm.filterTemplateOn),function(option,i){return _c('li',{staticClass:"list-group-item px-0"},[_vm._v("\n            "+_vm._s(option)+" "),_c('a',{staticClass:"btn-link float-right",attrs:{"href":"#"},on:{"click":function($event){_vm.removeTemplateFilter(i)}}},[_vm._v("remove")])])})),_vm._v(" "),(!_vm.filterTemplateOn)?_c('span',{staticClass:"alert alert-danger"},[_vm._v("No terms defined - requires at least one term in order to function")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-link float-right ml-2",attrs:{"href":"#"},on:{"click":_vm.resetFieldFilter}},[_vm._v("Reset to\n          default")]),_vm._v(" "),_c('p',[_vm._v("Terms used to match the secret's field which is used to generate the One Time\n          Passwords.")]),_vm._v(" "),_c('div',{staticClass:"input-group mb-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.newFieldFilter),expression:"form.newFieldFilter"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.form.newFieldFilter)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.preventDefault();_vm.postFieldFilter($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "newFieldFilter", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":_vm.postFieldFilter}},[_vm._v("\n              Add term\n            ")])])]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((_vm.filterFieldOn),function(option,i){return _c('li',{staticClass:"list-group-item px-0"},[_vm._v("\n            "+_vm._s(option)+" "),_c('a',{staticClass:"btn-link float-right",attrs:{"href":"#"},on:{"click":function($event){_vm.removeFieldFilter(i)}}},[_vm._v("remove")])])})),_vm._v(" "),(!_vm.filterFieldOn)?_c('span',{staticClass:"alert alert-danger"},[_vm._v("No terms defined - requires at least one term in order to function")]):_vm._e()]):_vm._e()])])])}
var staticRenderFns = []


/***/ }),

/***/ "ePdZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon upload-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M9,16V10H5L12,3L19,10H15V16H9M5,20V18H19V20H5Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "efj3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DeleteIcon",
  props: {
    title: {
      type: String,
      default: "Delete icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "ehzB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Disclaimer_vue__ = __webpack_require__("VrdI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62059978_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Disclaimer_vue__ = __webpack_require__("hCeq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Disclaimer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62059978_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Disclaimer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62059978_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Disclaimer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f7RK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HelpCircle_vue__ = __webpack_require__("Fl5E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7eb860be_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_HelpCircle_vue__ = __webpack_require__("8Xx2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_HelpCircle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7eb860be_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_HelpCircle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_7eb860be_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_HelpCircle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gYtk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBanner)?_c('router-link',{staticClass:"offline-banner text-center white-text",attrs:{"to":{name:'settings.offline'}}},[_c('p',{staticClass:"z-depth-1"},[_vm._v("You're in "),_c('strong',[_vm._v("encrypted offline mode")])])]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "gZ2L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand navbar-dark bg-dark purple darken-4"},[_c('router-link',{staticClass:"navbar-brand",staticStyle:{"-webkit-app-region":"drag"},attrs:{"to":"/","href":"/"}},[_c('img',{attrs:{"src":__webpack_require__("16DI"),"height":"40"}})]),_vm._v(" "),_c('div',{staticClass:"navbar-collapse",attrs:{"id":"navbar"}},[(!_vm.loggedin)?_c('ul',{staticClass:"navbar-nav mr-auto mt-2 mt-lg-0"},[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/login"}},[_vm._v("Login")])],1)]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"navbar-nav ml-auto"},[(_vm.loggedin)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/"}},[_c('lock-clock-icon'),_vm._v("\n          Authenticators\n        ")],1)],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"},on:{"click":_vm.showHelp}},[_c('help-circle-outline-icon'),_vm._v("\n          Help\n        ")],1)]),_vm._v(" "),(_vm.loggedin)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/settings"}},[_c('settings-icon'),_vm._v("\n          Settings\n        ")],1)],1):_vm._e(),_vm._v(" "),(_vm.loggedin&&_vm.okey)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:;;"},on:{"click":_vm.logoutUser}},[_c('lock-icon'),_vm._v("\n          Lock\n        ")],1)]):_vm._e(),_vm._v(" "),(_vm.loggedin&&!_vm.okey)?_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:;;"},on:{"click":_vm.logoutUser}},[_c('close-icon'),_vm._v("\n          Logout\n        ")],1)]):_vm._e()])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "gq7E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DownloadIcon",
  props: {
    title: {
      type: String,
      default: "Download icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "h4U4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LockClock_vue__ = __webpack_require__("YsJY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6a21dc70_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_LockClock_vue__ = __webpack_require__("4Ggg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LockClock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6a21dc70_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_LockClock_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6a21dc70_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_LockClock_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hCeq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"content-popup container-fluid d-block scrollbar py-2 white",class:{'white card' : !_vm.loggedin}},[_c('div',{staticClass:"container"},[_c('button',{staticClass:"btn btn-outline-secondary my-2 float-right",on:{"click":_vm.hide}},[_vm._v("× Close")]),_vm._v(" "),_c('h1',[_vm._v("DISCLAIMER")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("\n      Be safe & secure: always check if the site is using https in your browser, the compiled versions of the app are\n      signed with a valid signature and the online versions are hosted with a valid SSL certificate.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      You never submit data to our servers, the app runs inside your browser or the compiled app connects for you\n      to your own Thycotic Secret Server. You do not create an account or submit your private Secret Server Account\n      and password to us or our systems. Downloaded data does no leave your computer / your browser. We make it easy\n      for you to\n      access and interact with the OTP Authenticators that are stored and shared in your Thycotic Secret Server.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      We are not responsible for any data loss and or Passwords, unauthorized access to Secret Server. some of the\n      underlying Java script libraries we use are under active development. While we have thoroughly tested\n      successfully by people all over the globe, there is always the possibility something unexpected can happens that\n      can cause an error to connect to your Thycotic Secret Server interface or cause an account lock while trying to\n      login too many times unsuccessful. ")]),_vm._v(" "),_c('p',[_vm._v("\n      Permission is hereby granted, free of charge, to any person obtaining a copy of this free version software and\n      associated documentation files (the \"Free Version Software\"), to use in the Software without restriction, with\n      the small limitation of rights to modify, merge, publish, distribute, sublicense, and/or sell copies of the\n      Software, and to permit persons to whom the Software is furnished to do so, subject to the following\n      conditions: ")]),_vm._v(" "),_c('p',[_vm._v("\n      The above copyright notice and this permission notice shall be included in all copies or substantial portions of\n      the Software.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      THE SOFTWARE IS PROVIDED \"AS IS\", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO\n      THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. IN NO EVENT SHALL THE\n      AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF\n      CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER\n      DEALINGS IN THE SOFTWARE.\n    ")])])]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "i852":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "StarOutlineIcon",
  props: {
    title: {
      type: String,
      default: "Star Outline icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "iAh9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events_event_hub__ = __webpack_require__("B6dM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'help',
  data: function data() {
    return {
      active: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])({
    loggedin: 'auth/loggedin'
  })),
  methods: {
    hide: function hide() {
      this.active = false;
    },
    show: function show() {
      this.active = true;
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$on('help-show', this.show);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__events_event_hub__["a" /* default */].$off('help-show');
  }
});

/***/ }),

/***/ "iI3b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ViewList_vue__ = __webpack_require__("Fx8p");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_77d53f89_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ViewList_vue__ = __webpack_require__("+uiI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ViewList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_77d53f89_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ViewList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_77d53f89_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_ViewList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "keaL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CloudOutlineIcon",
  props: {
    title: {
      type: String,
      default: "Cloud Outline icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "kmFC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "knv1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"content-popup container-fluid d-block scrollbar py-2 white",class:{'white card' : !_vm.loggedin}},[_c('div',{staticClass:"container"},[_c('button',{staticClass:"btn btn-outline-secondary my-2 float-right",on:{"click":_vm.hide}},[_vm._v("× Close")]),_vm._v(" "),_c('h1',[_vm._v("Need help?")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("THE 4PASSWORD AUTHENTICATOR")]),_vm._v(" "),_c('p',[_vm._v("The goal of the 4Passwords Authenticator app is to efficiently and securely use online or cached offline\n      One-time Passwords (OTP’s) that are shared and stored within a Thycotic On-premise of cloud based Secret\n      Server.")]),_vm._v(" "),_c('p',[_vm._v("The 4Passwords Authenticator is a client-side app that runs exclusively in a client’s browser and\n      computer. Once the application is downloaded from either 4Passwords.com, 4pa.app or your own hosted servers,\n      then the app will receive and send data through the app with the configured Thycotic Secret Server and its\n      enabled web services API. The app will never send any data to any other system or website then the configured\n      Secret Server within the app.")]),_vm._v(" "),_c('p',[_vm._v("The optional offline cache will be protected by a passphrase that encrypts your OTP keys inside the app or\n      browser cache with 256-bit AES encryption.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Application feature overview.")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("What are One-time Passwords?")]),_vm._v(" "),_c('p',[_vm._v("One-time Passwords (OTP’s) are also known as Google , Microsoft, TOTP Authenticators, and as MFA\n      (Multi-factor), 2FA (Two factor Authentication) Keys.")]),_vm._v(" "),_c('p',[_vm._v("All One-time Password techniques do in principle the same: During an authentication process the server requests\n      to the client to respond with a numeric challenge. Both sides will calculate a number based on a shared key and\n      the time. As the client and the server both hold the same key and if the time on the client and server are in\n      sync then the client and server will generate the same number. The client can then respond correctly to the\n      challenge without exposing its key on the network.")]),_vm._v(" "),_c('p',[_vm._v("The challenge with traditional OTP tools for One-time password usage, is that the keys are stored externally on\n      the server and in the client. This key is mostly presented One-time to the client and are often not stored\n      centrally in an Enterprise PAM solution, but saved in a third party authenticator app per person, per account on\n      separated devices. These apps have also no auditing or other methods of sharing these keys. Managing these keys\n      is then a lot of manual work to manage, share, store or update these keys. This complicates things and often\n      results in not using a Two factor authentication at all in external accounts. While the accounts that can be\n      benefit and be protected with this extra layer of security are often also high privileged accounts.\n    ")]),_vm._v(" "),_c('p',[_vm._v("To not use a Two factor Authentication when possible is simple not secure enough.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("First time usage.")]),_vm._v(" "),_c('p',[_vm._v("Please make sure your System administrator has prepared Thycotic Secret Server for the usage of this APP. see\n      the ADMIN section below for the configuration guidelines.")]),_vm._v(" "),_c('p',[_vm._v("The initial screen is the setup wizard screen. As described below, follow the Configuration wizard,\n      alternatively you can switch to manual mode.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Configuration wizard")]),_vm._v(" "),_c('p',[_vm._v("When the app is loaded for the first time, it will not detect any previous settings or the offline cached mode.\n    ")]),_vm._v(" "),_c('p',[_vm._v("The setup wizard will guide you through the 4 main steps in configuring the app.")]),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('p',[_vm._v("This step will search automatically for an existing user preferences secret and or any global Autodiscover\n      preferences.")]),_vm._v(" "),_c('p',[_vm._v("The screen may show additional screen before the final state it found. please wait until its finished.")]),_vm._v(" "),_c('p',[_vm._v("Below you see the three possible screens the setup wizard can show.")]),_vm._v(" "),_c('p',[_vm._v("No preferences found, manual configuration required.")]),_vm._v(" "),_c('p',[_vm._v("If the app fails to find any preferences secrets then the app will ask you to supply a template ID.")]),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('p',[_vm._v("Autodiscover references found and loaded, almost done.")]),_vm._v(" "),_c('p',[_vm._v("In this situation the Autodiscover secrets were found and loaded. you can continue with the next step to setup\n      your offline passphrase")]),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_c('p',[_vm._v("User preferences found and loaded, no configuration remaining")]),_vm._v(" "),_c('p',[_vm._v("In this situation the user preferences secrets were found and loaded. This has loaded your previous set\n      favorites, offline password and other application settings that may apply. you can continue to start using the\n      app")]),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_c('p',[_vm._v("Offline Mode")]),_vm._v(" "),_c('p',[_vm._v("The offline mode step asks you for a passphrase. with this passphrase the app will encrypt all local storage as\n      cache with 256 bit AES encryption. This will enable the offline mode and the option to store your settings,\n      favorite and offline passphrase in secret server in a user preferences file.")]),_vm._v(" "),_c('p',[_vm._v("In the offline mode the 4PA Authenticator app can be used without an active internet connection. This is\n      optional and requires that you to create an offline passphrase. This passphrase is used to encrypt your data\n      locally.")]),_vm._v(" "),_c('p',[_vm._v("If disabled or not configured, your session is limited to 20 minutes and you will be logged out after\n      expiration.")]),_vm._v(" "),_c('p',[_vm._v("Please note, whilst in offline mode it is not possible to retrieve new data without going online first.")]),_vm._v(" "),_vm._m(5,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Manual mode: login form")]),_vm._v(" "),_c('p',[_vm._v("The manual mode login form shows the default login fields required.")]),_vm._v(" "),_c('p',[_vm._v("Use the remember me toggle to save these fields for next time usage.")]),_vm._v(" "),_vm._m(6,false,false),_vm._v(" "),_vm._m(7,false,false),_vm._v(" "),_vm._m(8,false,false),_vm._v(" "),_vm._m(9,false,false),_vm._v(" "),_vm._m(10,false,false),_vm._v(" "),_c('p',[_vm._v("See or run for additional help and information the Setup wizard.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Troubleshooting Failed login attempts")]),_vm._v(" "),_c('p',[_vm._v("Be careful with trying to login too many times with an incorrect login attempt.")]),_vm._v(" "),_c('p',[_vm._v("An incorrect OTP also counts as an incorrect login.")]),_vm._v(" "),_vm._m(11,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Using the 4Passwords Authenticator")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Authenticators")]),_vm._v(" "),_c('p',[_vm._v("When you click on an authenticator it will copy the response code in the clip-board.")]),_vm._v(" "),_c('p',[_vm._v("You can set or unset an Authenticator as favorite by toggling the star icon.")]),_vm._v(" "),_vm._m(12,false,false),_vm._v(" "),_vm._m(13,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Reload authenticators")]),_vm._v(" "),_c('p',[_vm._v("This function will reload / refresh all Authenticator secrets you have permission to with the authenticators\n      and its data from Secret Server.")]),_vm._v(" "),_c('p',[_vm._v("You need to be in the online mode to use this feature.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Lock / Unlock mode")]),_vm._v(" "),_c('p',[_vm._v("The lock icon will lock a session within the app or browser. you can unlock offline with your passphrase.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Switch to Offline or Online mode")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("You're in encrypted offline mode")]),_vm._v(" "),_c('p',[_vm._v("When you are in Offline mode, you will see a green bar in the top of the screen, this means you API access\n      token from secret server is expired.")]),_vm._v(" "),_vm._m(14,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("The Online mode")]),_vm._v(" "),_c('p',[_vm._v("When in Online mode you can switch to offline mode")]),_vm._v(" "),_vm._m(15,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Settings")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Save to Server")]),_vm._v(" "),_c('p',[_vm._v("You can save your user setting (favorites, settings and offline passphrase to secret server if you are in the\n      online mode.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Import from Server")]),_vm._v(" "),_c('p',[_vm._v("You can load your user setting (favorites, settings and offline passphrase from secret server if you are in the\n      online mode.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Edit settings on Server")]),_vm._v(" "),_c('p',[_vm._v("This will open the Thycotic Secret Server secret view of your user preferences secret. if you are in the online\n      mode.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("ADMIN: Configure Thycotic Secret Server")]),_vm._v(" "),_c('p',[_vm._v("Your System administrator should prepare Thycotic Secret Server in advance before usage. please make sure the\n      following steps are taken.")]),_vm._v(" "),_c('p',[_vm._v("Secret Server Requirements")]),_vm._v(" "),_vm._m(16,false,false),_vm._v(" "),_vm._m(17,false,false),_vm._v(" "),_vm._m(18,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Offline copy & install")]),_vm._v(" "),_c('p',[_vm._v("You can save this webpage offline and use it as a local app or host it inside your own organization\n      internally.")]),_vm._v(" "),_c('p',[_vm._v("In future versions we will provide a Windows, OSX & linux versions as a compiled app. this will be done\n      with the Electron framework where other famous tools like Slack/Skype/Discord are made with.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Feedback/support/bug reports")]),_vm._v(" "),_c('p',[_vm._v("We would love to read your feedback on this application. Please contact us at support@4passwords.com.")]),_vm._v(" "),_c('p')])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Retrieve One-time Password keys from a centrally configured Thycotic Secret Server and a predefined\n        Authenticator template.\n      ")]),_vm._v(" "),_c('li',[_vm._v("Efficiently share and update One-time Passwords within an organization.")]),_vm._v(" "),_c('li',[_vm._v("Provide an Online and encrypted Offline cache mode.")]),_vm._v(" "),_c('li',[_vm._v("Create a preferred list of favorited One-time Passwords, separate from the native Secret Server favorited\n        secret list.\n      ")]),_vm._v(" "),_c('li',[_vm._v("Safe and load application settings, offline passphrase and the favorites list inside a personal preference\n        secret inside the configured Thycotic Secret Server.\n      ")]),_vm._v(" "),_c('li',[_vm._v("Administrators can prepare an Autodiscover companywide preference secret that can assist all users within a\n        secret server to find the preferred Authenticator template. This can be set per domain.\n      ")]),_vm._v(" "),_c('li',[_vm._v("Cross platform usage on any mobile and desktop web browser that supports java script.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("Secret Server URL & Authentication Domain")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Provide your full Secret Server URL.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("make sure you use HTTPS:// and the optional subfolder")])]),_vm._v(" "),_c('li',[_vm._v("Provide your Domain Name.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("this field, should contain either your domain name as you see in the dropdown box of your secret server,\n            or the word local for local account login, or empty to use the default domain listed in Secret\n            Server.\n          ")])]),_vm._v(" "),_c('li',[_vm._v("Press the Next step button to continue.")])]),_vm._v(" "),_c('li',[_vm._v("User Credentials")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Provide your username")]),_vm._v(" "),_c('li',[_vm._v("Provide your password")]),_vm._v(" "),_c('li',[_vm._v("Provide your Authenticator code")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("if left blank and an authenticator is required, this will count as a failed login.")]),_vm._v(" "),_c('li',[_vm._v("make sure to wait on the OTP refresh so the code is correct. you can lock your Thycotic Secret Server\n            account if trying too many times, with a wrong OTP code or password.\n          ")]),_vm._v(" "),_c('li',[_vm._v("when login fails too many times, there can be a clock sync problem on your workstation and on the\n            server. these both need to be in sync.\n          ")])]),_vm._v(" "),_c('li',[_vm._v("Press the login button")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("If successful, the wizard will continue to the next step.")])])]),_vm._v(" "),_c('li',[_vm._v("4PA Settings")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('ul',[_c('li',[_vm._v("If requested supply the Authenticator template ID.")]),_vm._v(" "),_c('li',[_vm._v("Most likely your Thycotic Secret Server Admin did not prepare secret server with Autodiscover preference\n          secrets, or you do not have permission on any of the preference secrets.\n        ")]),_vm._v(" "),_c('li',[_vm._v("You can find the Authenticator Template ID manually by creating a new secret with the Authenticator\n          template. The numeric ID is in the URL of the template.\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('ul',[_c('li',[_vm._v("Press the Next step button to continue.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('ul',[_c('li',[_vm._v("Press the \"To authenticators\" button to close the wizard.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('ul',[_c('li',[_vm._v("Provide an offline passphrase and press the \"Enable offline mode\". this completes the setup\n          wizard.\n        ")]),_vm._v(" "),_c('li',[_vm._v("Optionally continue as an online-only session.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Secret Server URL (https://)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Username")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Password")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("User Domain")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("One-time Password")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Leave empty, if your account does not have Two factor enabled.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Always make sure you can login to Secret Server first without a problem.")]),_vm._v(" "),_c('li',[_vm._v("You can lock your account in Secret Server with too many login attempts.")]),_vm._v(" "),_c('li',[_vm._v("The One-time Password is valid only once within 30 seconds. If it was used in a failed login attempt it\n        cannot be used again. please wait 30 seconds.\n      ")]),_vm._v(" "),_c('li',[_vm._v("Our advice is to Login to Secret Server manually after 2 or 3 failed attempts.")]),_vm._v(" "),_c('li',[_vm._v("IT can be you have a password change pending with Secret Server.")]),_vm._v(" "),_c('li',[_vm._v("IT can be you have a captcha challenge on the login from with secret server as a result of too many failed\n        login attempts\n      ")]),_vm._v(" "),_c('li',[_vm._v("An OTP token can be out of sync in time.")]),_vm._v(" "),_c('li',[_vm._v("Make sure the time is correct and in sync with an NTP source on both the computer and the server.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Alternatively you could wait for the token to switch on the 30 second mark and then login.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("make sure to set an offline passphrase and save the settings in the online mode. in this way your favorites\n        can be loaded in multiple sessions.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("you need to save the favorites and other settings manually by going to settings > Save setting to\n        server.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("click on the green bar or goto:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Settings > Encrypted offline mode.")]),_vm._v(" "),_c('li',[_vm._v("Login again for Online mode")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("goto: Settings > Encrypted offline mode.")]),_vm._v(" "),_c('li',[_vm._v("activate: Switch to offline mode")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("This will remove your Thycotic Secret Server API access token. you will need to login again if you want to\n          refresh Authenticators, save or load settings\n        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("Have the webservices Enabled (webservices API)")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("From the Thycotic Interface go:")]),_vm._v(" "),_c('li',[_vm._v("Admin > General > Enable Webservices: Yes")]),_vm._v(" "),_c('li',[_vm._v("Default session timeout is 20 Minutes, this means that your online session will always be maximum 20\n          minutes.\n        ")]),_vm._v(" "),_c('li',[_vm._v("Ip restriction can be applied on a Thycotic Secret Server users account, limiting the physical place or\n          network users can connect to Secret server from the app. The IP restriction do not apply when users are\n          working in the Offline mode.\n        ")])]),_vm._v(" "),_c('li',[_vm._v("Have an 4PA compatible Authenticator Template")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The fastest way to get started is to import our template."),_c('a',{attrs:{"href":"https://4pa.app/templates/TSS-4PA-Authenticator-Template.txt"}},[_c('br'),_vm._v("Save the template")])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("From Secret Server as Admin go: Admin > Secret Templates")]),_vm._v(" "),_c('li',[_vm._v("Paste the downloaded template in the \"Import Secret Templates\" section")])]),_vm._v(" "),_c('li',[_vm._v("To manually create an Authenticator template:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Give the Template a name starting with “Authenticator”")]),_vm._v(" "),_c('li',[_vm._v("Minimum we need is one field that contains the Authenticator code, with the name “restorecode”\n            as password field.\n          ")])])]),_vm._v(" "),_c('li',[_vm._v("Create an Company wide auto discover preferences Secret. This will enable all users within a domain to use a\n        specific Authenticator template from Secret Server.\n      ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Create a secret from any web enabled Template from Secret Server.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Give the Secret the\n            name:"),_c('em',[_vm._v("4pa_autodiscover_domain_preferences")])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("where the domain word needs to be changed to is the actual domain name that a user will use in the\n              domain field from login. If there are multiple variants to fill in the domain name then create several\n              records with these names.\n            ")]),_vm._v(" "),_c('li',[_vm._v("This can also be the Thycotic alternate name or the word \"local\" for local account preferences.\n              optionally it can also be left blank and made a global preference with \"4pa_autodiscover_preferences\".\n            ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("examples:"),_c('br'),_c('em',[_vm._v("4pa_Autodiscover_mydomain_preferences"),_c('br'),_vm._v(" 4pa_Autodiscover_mydomain.corp_preferences\n      "),_c('br'),_vm._v("4pa_Autodiscover_local_preferences"),_c('br'),_vm._v(" 4pa_Autodiscover_preferences"),_c('br')]),_c('em')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('ul',[_c('li',[_vm._v("Add in the notes field a json object with the correct Authenticator Template ID for your\n          domain.\n        ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("example: copy and paste the line below, and change the #### in the numeric Authenticator template\n            Id"),_c('br'),_c('b',[_vm._v("{\"templateId\":\"####\"}"),_c('br')])]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Note: the template ID will be different on each secret server.")]),_vm._v(" "),_c('li',[_vm._v("To quickly retrieve your authenticator template id:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("view the ID in the URL header when you create a secret from Secret Server with the Authenticator\n                template.\n              ")])])])]),_vm._v(" "),_c('li',[_vm._v("The other fields like a password, the URL or the username are ignored, but can be required fields in\n          secret server.\n        ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Add as user-id: 4pa_preferences")]),_vm._v(" "),_c('li',[_vm._v("Add as URL: the URL of your secret server")]),_vm._v(" "),_c('li',[_vm._v("generate a random password.")])]),_vm._v(" "),_c('li',[_vm._v("Save the secret and share it with the correct scope and permissions so all targeted users can find this\n          secret.\n        ")])])])}]


/***/ }),

/***/ "kyAZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CheckboxMarked_vue__ = __webpack_require__("pDxV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1c506847_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CheckboxMarked_vue__ = __webpack_require__("BunX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CheckboxMarked_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1c506847_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CheckboxMarked_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1c506847_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_CheckboxMarked_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lTNa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ContentCopyIcon",
  props: {
    title: {
      type: String,
      default: "Content Copy icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "lczC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon cloud-outline-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M19,18H6C3.79,18 2,16.21 2,14C2,11.79 3.79,10 6,10H6.71C7.37,7.69 9.5,6 12,6C15.04,6 17.5,8.46 17.5,11.5V12H19C20.66,12 22,13.34 22,15C22,16.66 20.66,18 19,18M19.35,10.03C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.03C2.34,8.36 0,10.9 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.03Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "lhHW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SettingsIcon",
  props: {
    title: {
      type: String,
      default: "Settings icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "n9S4":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "nyoq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'card': _vm.showNavigation },attrs:{"id":"app"}},[(_vm.showNavigation)?_c('site-navigation'):_vm._e(),_vm._v(" "),_c('offline-mode'),_vm._v(" "),(_vm.showNavigation)?_c('feedback'):_vm._e(),_vm._v(" "),_c('loading'),_vm._v(" "),(!_vm.isAppLoading)?_c('router-view'):_vm._e(),_vm._v(" "),_c('help'),_vm._v(" "),_c('privacy'),_vm._v(" "),_c('disclaimer')],1)}
var staticRenderFns = []


/***/ }),

/***/ "oyKP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CloudOffOutlineIcon",
  props: {
    title: {
      type: String,
      default: "Cloud Off Outline icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "pDxV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CheckboxMarkedIcon",
  props: {
    title: {
      type: String,
      default: "Checkbox Marked icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "pLdQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 d-flex"},[_c('div',{staticClass:"white px-0 h-100",class:{'no-fav':!_vm.favoriteFeature},attrs:{"id":"cl"}},[_c('div',{staticClass:"search-form"},[_c('div',{staticClass:"search-input"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"form-control search",attrs:{"type":"text","placeholder":"Search authenticator"},domProps:{"value":(_vm.query)},on:{"keyup":_vm.sbTop,"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"type":"button","aria-haspopup":"true","aria-expanded":"false"},on:{"click":_vm.clearQuery}},[(!_vm.query)?_c('magnify-icon'):_vm._e(),_vm._v(" "),(_vm.query)?_c('close-circle-icon'):_vm._e()],1)]),_vm._v(" "),_c('p',{staticClass:"form-inline mb-0"},[(!_vm.offlineMode)?_c('button',{staticClass:"btn btn-link btn-sm auth-reload",attrs:{"disabled":_vm.dispatching},on:{"click":_vm.refreshAuthenticators}},[_c('reload-icon'),_vm._v("\n          Reload authenticators\n        ")],1):_vm._e(),_vm._v(" "),_c('small',{staticClass:"auth-count"},[(_vm.query)?_c('span',[_c('b',[_vm._v(_vm._s(_vm.filteredSecrets.length))]),_vm._v(" of the\n          ")]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('b',[_vm._v(_vm._s(_vm.secretsCount)+" authenticators")]):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"code"},domProps:{"value":'key'}})])]),_vm._v(" "),(_vm.favoriteFeature)?_c('div',{staticClass:"tabs"},[_c('a',{staticClass:"tab",class:{'active':_vm.filter==1},attrs:{"href":"#"},on:{"click":function($event){_vm.setFilter(1)}}},[_vm._v("Favorited")]),_vm._v(" "),_c('a',{staticClass:"tab",class:{'active':_vm.filter==0},attrs:{"href":"#"},on:{"click":function($event){_vm.setFilter(0)}}},[_vm._v("All")])]):_vm._e()]),_vm._v(" "),(!_vm.loading)?_c('div',{staticClass:"list-group-flush sidenav scrollbar scrollbar-primary d-block",attrs:{"id":"ccl"}},[_c('div',{style:({height: _vm.sb})},[(_vm.slicedSecrets.length == 0)?_c('p',{staticClass:"p-4 purple lighten-5"},[_vm._v("\n          There are no authenticators matching this search query.\n        ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"d-block grey lighten-4",style:({height : _vm.beforeHeight })}),_vm._v(" "),_c('ul',{staticClass:"d-block",style:({height : _vm.currentHeight })},_vm._l((_vm.slicedSecrets),function(secret){return _c('authenticator',{key:secret.id,attrs:{"secretId":secret.id,"time":_vm.time}})}))])]):_vm._e()])])}
var staticRenderFns = []


/***/ }),

/***/ "prOb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "MagnifyIcon",
  props: {
    title: {
      type: String,
      default: "Magnify icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "qC+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__ = __webpack_require__("AqLG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jssha__ = __webpack_require__("TGyQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jssha___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jssha__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);







var addAuthenticator = function addAuthenticator(state, model) {
  model.showOtp = state.showOtp;
  __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].set(state.all, model.id, model);
};

var dec2hex = function dec2hex(s) {
  return (s < 15.5 ? '0' : '') + Math.round(s).toString(16);
};

var hex2dec = function hex2dec(s) {
  return parseInt(s, 16);
};

var leftpad = function leftpad(str, len, pad) {
  if (len + 1 >= str.length) {
    str = Array(len + 1 - str.length).join(pad) + str; // eslint-disable-line no-param-reassign
  }
  return str;
};

var multiIncludes = function multiIncludes(text, values) {
  var re = new RegExp(values.join('|'), 'i');
  return re.test(text);
};

var base32tohex = function base32tohex(base32) {
  var base32chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
  var bits = "";
  var hex = "";

  for (var i = 0; i < base32.length; i++) {
    var val = base32chars.indexOf(base32.charAt(i).toUpperCase());
    bits += leftpad(val.toString(2), 5, '0');
  }

  for (var y = 0; y + 4 <= bits.length; y += 4) {
    var chunk = bits.substr(y, 4);
    hex += parseInt(chunk, 2).toString(16);
  }
  return hex;
};

var regex = /[^a-zA-Z0-9]+/g;

var generate = function generate(key) {
  if (key.length === 0) {
    return '';
  }

  var otp = '';
  try {
    key = key.replace(regex, '');

    var epoch = Math.round(new Date().getTime() / 1000.0);
    var time = leftpad(dec2hex(Math.floor(epoch / 30)), 16, '0');

    var shaObj = new __WEBPACK_IMPORTED_MODULE_4_jssha___default.a("SHA-1", "HEX");
    shaObj.setHMACKey(base32tohex(key), "HEX");
    shaObj.update(time);
    var hmac = shaObj.getHMAC("HEX");
    if (hmac == 'KEY MUST BE IN BYTE INCREMENTS') {
      return '';
    }
    var offset = hex2dec(hmac.substring(hmac.length - 1));
    // otp = (hex2dec(hmac.substr(offset * 2, 8)) & hex2dec('7fffffff')) + '';
    otp = String(hex2dec(hmac.substr(offset * 2, 8)) & hex2dec('7fffffff'));
    otp = otp.substr(otp.length - 6, 6);
  } catch ($e) {
    // do nothing
  }
  return otp;
};

var state = {
  all: {},
  favorites: [],
  templateId: false,
  siteId: null,
  personalFolderId: null,
  settingsId: null,
  filterTemplateOn: ["auth"],
  filterFieldOn: ["restorecode", "authcode"]
};

var getters = {
  all: function all() {
    return state.all;
  },
  favorites: function favorites() {
    return state.favorites;
  },
  templateId: function templateId() {
    return state.templateId;
  },
  personalFolderId: function personalFolderId() {
    return state.personalFolderId;
  },
  settingsId: function settingsId() {
    return state.settingsId;
  },
  filterTemplateOn: function filterTemplateOn() {
    return state.filterTemplateOn;
  },
  filterFieldOn: function filterFieldOn() {
    return state.filterFieldOn;
  },
  getById: function getById(state) {
    return function (id) {
      return state.all[id];
    };
  },
  siteId: function siteId() {
    return state.siteId;
  }

};

var extractSecret = function extractSecret(payload) {
  var fieldId = findFieldId(payload);
  var input = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(payload.items, function (field) {
    if (field.fieldId == fieldId) {
      return true;
    }
  });
  if (!input || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(input).length == 0) {
    return false;
  }
  var secret = input[0].itemValue;
  if (secret) {
    return secret;
  }
  return 0;
};

var findFieldId = function findFieldId(payload) {
  // Fields
  var fieldId = false;
  __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.filter(payload.items, function (item) {
    if (item.fieldName == "") return false;
    var name = multiIncludes(item.fieldName, getters.filterFieldOn());

    if (name) {
      fieldId = item.fieldId;
      return true;
    }
  });
  return fieldId;
};

var actions = {
  getAuthenticators: function getAuthenticators(_ref, params) {
    var commit = _ref.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].getAuthenticators(params).then(function (data) {
      return commit('receiveAll', data.records);
    });
  },
  getAuthenticator: function getAuthenticator(_ref2, payload) {
    var commit = _ref2.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].getAuthenticator(payload).then(function (data) {
      return commit('receiveAuthenticator', data);
    });
  },
  setTemplateId: function setTemplateId(_ref3, id) {
    var commit = _ref3.commit;

    return commit('setTemplateId', id);
  },
  setSettingsId: function setSettingsId(_ref4, id) {
    var commit = _ref4.commit;

    return commit('setSettingsId', id);
  },
  setPersonalFolderId: function setPersonalFolderId(_ref5, id) {
    var commit = _ref5.commit;

    return commit('setPersonalFolderId', id);
  },
  setSiteId: function setSiteId(_ref6, id) {
    var commit = _ref6.commit;

    return commit('setSiteId', id);
  },
  generateOtp: function generateOtp(_ref7, payload) {
    var commit = _ref7.commit;

    var secret = extractSecret(state.all[payload]);
    if (secret) {
      return commit('setOtp', { id: payload, otp: generate(secret) });
    }
    return false;
  },
  toggleShowOtp: function toggleShowOtp(_ref8, payload) {
    var commit = _ref8.commit;

    return commit('toggleShowOtp', payload);
  },
  toggleFavorite: function toggleFavorite(_ref9, id) {
    var commit = _ref9.commit;

    return commit('toggleFavorite', id);
  },
  addFieldFilter: function addFieldFilter(_ref10, payload) {
    var commit = _ref10.commit;

    return commit('addFieldFilter', payload);
  },
  addTemplateFilter: function addTemplateFilter(_ref11, payload) {
    var commit = _ref11.commit;

    return commit('addTemplateFilter', payload);
  },
  removeFieldFilter: function removeFieldFilter(_ref12, payload) {
    var commit = _ref12.commit;

    return commit('removeFieldFilter', payload);
  },
  removeTemplateFilter: function removeTemplateFilter(_ref13, payload) {
    var commit = _ref13.commit;

    return commit('removeTemplateFilter', payload);
  },
  resetFieldFilter: function resetFieldFilter(_ref14) {
    var commit = _ref14.commit;

    return commit('resetFieldFilter');
  },
  resetTemplateFilter: function resetTemplateFilter(_ref15) {
    var commit = _ref15.commit;

    return commit('resetTemplateFilter');
  },
  setFieldFilter: function setFieldFilter(_ref16, payload) {
    var commit = _ref16.commit;

    return commit('resetFieldFilter', payload);
  },
  setTemplateFilter: function setTemplateFilter(_ref17, payload) {
    var commit = _ref17.commit;

    return commit('resetTemplateFilter', payload);
  },
  clearState: function clearState(_ref18) {
    var commit = _ref18.commit;

    return commit('clearState');
  },
  clearAll: function clearAll(_ref19) {
    var commit = _ref19.commit;

    return commit('clearAll');
  },
  searchSecrets: function searchSecrets(_ref20, payload) {
    var commit = _ref20.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].searchSecrets(payload);
  },
  getStub: function getStub(_ref21) {
    var commit = _ref21.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].getStub();
  },
  getSecret: function getSecret(_ref22, id) {
    var commit = _ref22.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].getSecret(id);
  },
  putSecret: function putSecret(_ref23, id, payload) {
    var commit = _ref23.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].putSecret(id, payload);
  },
  postSecret: function postSecret(_ref24, payload) {
    var commit = _ref24.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].postSecret(payload);
  },
  postPreferences: function postPreferences(_ref25) {
    var commit = _ref25.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].postPreferences();
  },
  getPreferences: function getPreferences(_ref26, config) {
    var commit = _ref26.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].getPreferences(config);
  },
  getCompanyPreferences: function getCompanyPreferences(_ref27) {
    var commit = _ref27.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].getCompanyPreferences();
  },
  getPersonalFolderId: function getPersonalFolderId(_ref28) {
    var commit = _ref28.commit;

    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].getPersonalFolderId();
  },
  getFolders: function getFolders(params) {
    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].getFolders(params);
  },
  patchSecretField: function patchSecretField(id, params) {
    return __WEBPACK_IMPORTED_MODULE_2__services_Authenticators__["a" /* default */].patchSecretField(id, params);
  }
};

var mutations = {
  clearState: function clearState(state) {
    state.all = {};
    state.favorites = [];
    state.templateId = false;
    state.settingsId = false;
    state.personalFolderId = null;
    state.siteId = null;
    state.filterTemplateOn = ["auth"];
    state.filterFieldOn = ["restorecode", "authcode"];
  },
  receiveAll: function receiveAll(state, models) {
    models.forEach(function (model) {
      addAuthenticator(state, model);
    });
    if (state.siteId == null) {
      if (models[0] && models[0].siteId !== null) {
        state.siteId = Number([models[0].siteId]);
      } else {
        state.siteId = 1;
      }
    }
  },
  clearAll: function clearAll(state) {
    state.all = {};
  },
  receiveAuthenticator: function receiveAuthenticator(state, model) {
    var secret = extractSecret(model);
    model.otp = generate(secret);
    addAuthenticator(state, model);
  },
  addFieldFilter: function addFieldFilter(state, payload) {
    state.filterFieldOn.push(payload);
    localStorage.setItem('fieldFilter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.filterFieldOn));
  },
  removeFieldFilter: function removeFieldFilter(state, payload) {
    state.filterFieldOn.splice(payload, 1);
    localStorage.setItem('fieldFilter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.filterFieldOn));
  },
  resetFieldFilter: function resetFieldFilter(state) {
    state.filterFieldOn = ["restorecode", "authcode"];
    localStorage.setItem('fieldFilter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.filterFieldOn));
  },
  setSiteId: function setSiteId(state, id) {
    state.siteId = id;
  },
  setSettingsId: function setSettingsId(state, id) {
    state.settingsId = id;
  },
  setPersonalFolderId: function setPersonalFolderId(state, id) {
    state.personalFolderId = id;
  },
  setFieldFilter: function setFieldFilter(state, payload) {
    state.filterFieldOn = payload;
    localStorage.setItem('fieldFilter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.filterFieldOn));
  },
  addTemplateFilter: function addTemplateFilter(state, payload) {
    state.filterTemplateOn.push(payload);
    localStorage.setItem('templateFilter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.filterTemplateOn));
  },
  removeTemplateFilter: function removeTemplateFilter(state, payload) {
    state.filterTemplateOn.splice(payload, 1);
    localStorage.setItem('templateFilter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.filterTemplateOn));
  },
  resetTemplateFilter: function resetTemplateFilter(state) {
    state.filterTemplateOn = ["auth"];
    localStorage.setItem('templateFilter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.filterTemplateOn));
  },
  setTemplateFilter: function setTemplateFilter(state, payload) {
    state.filterTemplateOn = payload;
    localStorage.setItem('templateFilter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.filterTemplateOn));
  },
  setOtp: function setOtp(state, payload) {
    state.all[payload.id].otp = payload.otp;
  },
  toggleShowOtp: function toggleShowOtp(state, id) {
    state.all[id].showOtp = !state.all[id].showOtp;
  },
  toggleFavorite: function toggleFavorite(state, id) {
    var index = state.favorites.indexOf(id);
    if (index >= 0) {
      state.favorites.splice(index, 1);
    } else {
      state.favorites.push(id);
    }
  },
  setFavorites: function setFavorites(state, payload) {
    state.favorites = payload;
  },
  setTemplateId: function setTemplateId(state, id) {
    state.templateId = id;
    localStorage.setItem('templateId', id);
  },
  loadOffline: function loadOffline(state, store) {
    state.all = store.all;
    state.templateId = store.templateId;
    state.siteId = store.siteId;
    state.personalFolderId = store.personalFolderId;
    state.settingsId = store.settingsId;
    state.filterTemplateOn = store.filterTemplateOn;
    state.filterFieldOn = store.filterFieldOn;
    state.favorites = store.favorites;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "qRqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "OpenInNewIcon",
  props: {
    title: {
      type: String,
      default: "Open In New icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "qTl2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Reload_vue__ = __webpack_require__("FjUE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_58eb4ec3_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Reload_vue__ = __webpack_require__("YMHA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Reload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_58eb4ec3_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Reload_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_58eb4ec3_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Reload_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rFQp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_StarOutline_vue__ = __webpack_require__("i852");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2fd84a21_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_StarOutline_vue__ = __webpack_require__("uz4D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_StarOutline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2fd84a21_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_StarOutline_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2fd84a21_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_StarOutline_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rXQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfflineSettings_vue__ = __webpack_require__("WGpC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e24cb4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfflineSettings_vue__ = __webpack_require__("7nDA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfflineSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e24cb4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfflineSettings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2e24cb4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfflineSettings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sHGq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'offline-mode',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    offlineMode: 'auth/offlineMode',
    loggedin: 'auth/loggedin'
  }), {
    showBanner: function showBanner() {
      return this.offlineMode && this.loggedin;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    logout: 'auth/logout'
  }), {
    logoutUser: function logoutUser() {
      var _this = this;

      this.logout().then(function () {
        _this.$router.push({ name: 'login' });
        //return document.location.reload();
      });
      //this.$router.push({path: '/login'});
    }
  })
});

/***/ }),

/***/ "siN1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "slAo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feedback"},[(_vm.feedback.message)?_c('div',{staticClass:"mb-0",class:_vm.feedbackClass},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.clearFeedback}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v("\n        "+_vm._s(_vm.feedback.message)+"\n    ")]):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "toqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Eye_vue__ = __webpack_require__("Tf+x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_27b67e14_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Eye_vue__ = __webpack_require__("2/UD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Eye_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_27b67e14_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Eye_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_27b67e14_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Eye_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uz4D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon star-outline-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "vHwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon lock-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M12,17C13.1,17 14,16.1 14,15C14,13.89 13.1,13 12,13C10.9,13 10,13.9 10,15C10,16.1 10.9,17 12,17M18,8C19.1,8 20,8.9 20,10V20C20,21.1 19.1,22 18,22H6C4.9,22 4,21.1 4,20V10C4,8.89 4.9,8 6,8H7V6C7,3.24 9.24,1 12,1C14.76,1 17,3.24 17,6V8H18M12,3C10.34,3 9,4.34 9,6V8H15V6C15,4.34 13.66,3 12,3Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "vReH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SecurityCloseIcon",
  props: {
    title: {
      type: String,
      default: "Security Close icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "vaww":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AlertIcon",
  props: {
    title: {
      type: String,
      default: "Alert icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "vhOZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon checkbox-marked-outline-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M19,19H5V5H15V3H5C3.89,3 3,3.89 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V11H19M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"}})])])}
var staticRenderFns = []


/***/ }),

/***/ "wbZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Close_vue__ = __webpack_require__("1JkZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_450644b4_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Close_vue__ = __webpack_require__("Kl9A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Close_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_450644b4_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Close_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_450644b4_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Close_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_feedback__ = __webpack_require__("AiJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_loading__ = __webpack_require__("Lns1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_settings__ = __webpack_require__("THyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_authenticators__ = __webpack_require__("qC+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_secrettemplates__ = __webpack_require__("Cbhb");





/*----------  Modules  ----------*/

// import settings from './modules/settings';






__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var state = {};

var getters = {};

var actions = {
  asyncData: function asyncData() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([this.dispatch('loading/setLoading', true), this.dispatch("authenticators/getAuthenticators")]).then(function () {
      _this.dispatch('loading/setLoading', false);
    });
  }
};

var mutations = {
  initialiseStore: function initialiseStore(state) {
    // Check if the ID exists
    if (localStorage.getItem('store')) {
      this.replaceState(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, JSON.parse(localStorage.getItem('store'))));
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters,
  modules: {
    feedback: __WEBPACK_IMPORTED_MODULE_4__modules_feedback__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_5__modules_loading__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_6__modules_auth__["a" /* default */],
    settings: __WEBPACK_IMPORTED_MODULE_7__modules_settings__["a" /* default */],
    authenticators: __WEBPACK_IMPORTED_MODULE_8__modules_authenticators__["a" /* default */],
    secretTemplates: __WEBPACK_IMPORTED_MODULE_9__modules_secrettemplates__["a" /* default */]
  }
}));

/***/ }),

/***/ "wv/a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events_event_hub__ = __webpack_require__("B6dM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_design_icons_HelpCircleOutline__ = __webpack_require__("KEYh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_Settings__ = __webpack_require__("YRA+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_Close__ = __webpack_require__("wbZU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_LockClock__ = __webpack_require__("h4U4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_Lock_vue__ = __webpack_require__("8BXF");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    LockIcon: __WEBPACK_IMPORTED_MODULE_7_vue_material_design_icons_Lock_vue__["a" /* default */],
    SettingsIcon: __WEBPACK_IMPORTED_MODULE_4_vue_material_design_icons_Settings__["a" /* default */],
    CloseIcon: __WEBPACK_IMPORTED_MODULE_5_vue_material_design_icons_Close__["a" /* default */],
    HelpCircleOutlineIcon: __WEBPACK_IMPORTED_MODULE_3_vue_material_design_icons_HelpCircleOutline__["a" /* default */],
    LockClockIcon: __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_LockClock__["a" /* default */]
  },
  name: 'site-navigation',
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])({
    loggedin: 'auth/loggedin',
    isAdmin: 'auth/isAdmin',
    currentUser: 'auth/user',
    okey: 'settings/okey'
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    logout: 'auth/logout',
    setDelayedFeedback: 'feedback/setDelayedFeedback'
  }), {
    showHelp: function showHelp() {
      __WEBPACK_IMPORTED_MODULE_2__events_event_hub__["a" /* default */].$emit('help-show');
    },
    logoutUser: function logoutUser() {
      var _this = this;

      this.logout().then(function () {
        _this.$router.push({ name: 'login' });
        //return document.location.reload();
      });
    }
  })
});

/***/ }),

/***/ "x/9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CloseCircleIcon",
  props: {
    title: {
      type: String,
      default: "Close Circle icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    }
  }
});

/***/ }),

/***/ "xBry":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_SiteNavigation__ = __webpack_require__("3LPc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_OfflineMode__ = __webpack_require__("8G/l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loading__ = __webpack_require__("NxGh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Feedback_vue__ = __webpack_require__("OZEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Help__ = __webpack_require__("ZCnB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Privacy__ = __webpack_require__("MV//");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Disclaimer__ = __webpack_require__("ehzB");

//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import Auth from './services/Auth';


// import store from './store/store';






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Disclaimer: __WEBPACK_IMPORTED_MODULE_8__components_pages_Disclaimer__["a" /* default */],
    Privacy: __WEBPACK_IMPORTED_MODULE_7__components_pages_Privacy__["a" /* default */],
    Help: __WEBPACK_IMPORTED_MODULE_6__components_pages_Help__["a" /* default */],
    Feedback: __WEBPACK_IMPORTED_MODULE_5__components_Feedback_vue__["a" /* default */],
    SiteNavigation: __WEBPACK_IMPORTED_MODULE_1__components_layout_SiteNavigation__["a" /* default */],
    OfflineMode: __WEBPACK_IMPORTED_MODULE_2__components_OfflineMode__["a" /* default */],
    Loading: __WEBPACK_IMPORTED_MODULE_3__components_Loading__["a" /* default */]
  },
  watch: {
    expired: function expired(val) {
      if (val) {
        this.setOfflineMode(true);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])({
    isAppLoading: 'loading/isAppLoading',
    loggedin: 'auth/loggedin',
    expiry: 'auth/expiry'
  }), {
    expired: function expired() {
      return this.expiry < Math.floor(Date.now() / 1000);
    },
    showNavigation: function showNavigation() {
      return this.loggedin && this.$route.name !== "login" && !this.isAppLoading;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    setOfflineMode: 'auth/setOfflineMode'
  }))
});

/***/ }),

/***/ "xPdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Magnify_vue__ = __webpack_require__("prOb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_34e8c013_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Magnify_vue__ = __webpack_require__("xqnB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Magnify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_34e8c013_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Magnify_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_34e8c013_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_Magnify_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xZLE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authenticator_vue__ = __webpack_require__("e9KC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6603db87_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authenticator_vue__ = __webpack_require__("T6uP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authenticator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6603db87_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authenticator_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6603db87_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authenticator_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xqmF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading||_vm.isAppLoading)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"h-100 row m-auto"},[(_vm.isLoading)?_c('div',{staticClass:"m-auto"},[_vm._v("\n            Loading...\n        ")]):_vm._e(),_vm._v(" "),(!_vm.isLoading&&_vm.isAppLoading)?_c('div',{staticClass:"m-auto"},[_vm._v("\n            Getting data...\n        ")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "xqnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon magnify-icon",attrs:{"aria-hidden":_vm.decorative,"aria-label":_vm.title,"role":"img"}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"fill":_vm.fillColor,"width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M9.5,3C13.09,3 16,5.91 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16C5.91,16 3,13.09 3,9.5C3,5.91 5.91,3 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"}})])])}
var staticRenderFns = []


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.583b4e476fbaee4817e2.js